<template>
  <div id="sovSummery" style="text-transform: capitalize">
    <div
      data-html2canvas-ignore="true" v-show="loader || loader3 || loader4">
      <Loader />
    </div>

    <div class="datepickerwrap card">
      <div class="leftcontent wrapitem">
        <div class="datebox">
          <datepicker
            placeholder="From"
            @input="changeCustomDate"
            v-model="date.startDate"
          />
        </div>
        <div class="datebox customSelect" style="min-width: 17%">
          <select
            @change="websiteChanged"
            v-model="selected_SOVWebsite"
            class="form-control text-uppercase"
          >
            <optgroup label="Retail">
              <option value="all">All</option>
              <option value="https://www.amazon.com">Amazon US</option>
              <option value="https://www.amazon.fr">Amazon France</option>
              <option value="https://www.amazon.co.it">Amazon Italy</option>
              <option value="https://www.amazon.es">Amazon Spain</option>
              <option value="https://www.amazon.co.uk">Amazon UK</option>
              <option value="https://www.amazon.de">Amazon Germany</option>
              <option value="https://www.bestbuy.com">Best Buy US</option>
              <option value="https://www.newegg.com">Newegg</option>
              <option value="https://www.microcenter.com">Microcenter</option>
              <option value="https://www.costco.com">Costco US</option>
              <option value="https://www.currys.co.uk">Curry's UK</option>
              <option value="https://www.harveynorman.com.au">Harvey Norman AU</option>
              <option value="https://global.jd.com">JD GC</option>
              <option value="https://www.mediamarkt.de">MediaMarkt DE</option>
              <option value="https://www.walmart.com">Walmart US</option>
            </optgroup>
            <optgroup label="Consumer OEM">
              <option value="https://br-store.acer.com">Acer Brazil</option>
              <option value="https://store.acer.com/en-us">Acer US</option>
              <option value="https://www.asus.com/fr">ASUS France</option>
              <option value="https://store.asus.com/us">ASUS US</option>
              <option value="https://www.asus.com">ASUS WW</option>
              <option value="https://www.dell.com/en-au">Dell Australia</option>
              <option value="https://www.dell.com/ja-jp">Dell Japan</option>
              <option value="https://www.dell.com/en-us">Dell US</option>
              <option value="https://www.dell.com/en-uk">Dell UK</option>
              <option value="https://fmv.fccl.fujitsu.com">Fujitsu Japan</option>
              <option value="https://store.hp.com/FranceStore">HP France</option>
              <option value="https://www8.hp.com/jp">HP Japan</option>
              <option value="https://store.hp.com/mx-es">HP Mexico</option>
              <option value="https://store.hp.com/UKStore">HP UK</option>
              <option value="https://store.hp.com/us">HP US</option>
              <option value="https://www.lenovo.com/au">Lenovo Australia</option>
              <option value="https://s.lenovo.com.cn">Lenovo China</option>
              <option value="https://www.lenovo.com/fr">Lenovo France</option>
              <option value="https://www.lenovo.com/de">Lenovo Germany</option>
              <option value="https://www.lenovo.com/gb">Lenovo UK</option>
              <option value="https://www.lenovo.com/us">Lenovo US</option>
              <option value="https://www.nec-lavie.jp">NEC Japan</option>
            </optgroup>
            <optgroup label="Commercial OEM">
              <option value="https://www.hpstore.cn#commercial">
                Commercial HP China
              </option>
              <option value="https://store.hp.com/FranceStore#commercial">
                Commercial HP France
              </option>
              <option value="https://store.hp.com/GermanyStore#commercial">
                Commercial HP Germany
              </option>
              <option value="https://www8.hp.com/jp#commercial">
                Commercial HP Japan
              </option>
              <option value="https://store.hp.com/UKStore#commercial">
                Commercial HP UK
              </option>
              <option value="https://store.hp.com/us#commercial">Commercial HP US</option>
              <option value="https://b2b.lenovo.com.cn#commercial">
                Commercial Lenovo China
              </option>
              <option value="https://www.lenovo.com/fr#commercial">
                Commercial Lenovo France
              </option>
              <option value="https://www.lenovo.com/de#commercial">
                Commercial Lenovo Germany
              </option>
              <option value="https://www.lenovo.com/jp#commercial">
                Commercial Lenovo Japan
              </option>
              <option value="https://www.lenovo.com/gb#commercial">
                Commercial Lenovo UK
              </option>
              <option value="https://www.lenovo.com/us#commercial">
                Commercial Lenovo US
              </option>
            </optgroup>
            <optgroup label="Commercial Reseller">
              <option value="https://www.bechtle.com">Bechtle</option>
              <option value="https://www.cdw.com">CDW</option>
              <option value="https://www.inmac-wstore.com">Inmac</option>
              <option value="https://www.insight.com/en-US">Insight</option>
              <option value="https://www.connection.com">PC Connection</option>
              <option value="https://www.shi.com">SHI</option>
              <option value="https://www.technoworld.com">TechnoWorld</option>
              <option value="https://www.dustin.no">Dustin Nordics Norway</option>
              <option value="https://www.dustin.se">Dustin Nordics Sweden</option>
              <option value="https://www.dustin.fi">Dustin Nordics Finland</option>
              <option value="https://www.dustin.dk">Dustin Nordics Denmark</option>
            </optgroup>
          </select>
        </div>
        <div class="datebox customSelect">
          <select v-model="device" @change="refresh" class="form-control text-uppercase">
            <option
              value="laptop"
              v-if="
                !(
                  selected_SOVWebsite == 'https://www.newegg.com' ||
                  selected_SOVWebsite == 'https://www.microcenter.com'
                )
              "
            >
              Laptop
            </option>
            <option
              value="desktop"
              v-if="
                !(
                  selected_SOVWebsite == 'https://www.newegg.com' ||
                  selected_SOVWebsite == 'https://www.microcenter.com'
                )
              "
            >
              Desktop
            </option>
            <option v-if="cpuGpuSites.includes(selected_SOVWebsite)" value="gpu">
              GPU
            </option>
            <option v-if="cpuGpuSites.includes(selected_SOVWebsite)" value="cpu">
              CPU
            </option>
            <option
              v-if="
                selected_SOVWebsite == 'https://www.lenovo.com/us#commercial' ||
                selected_SOVWebsite == 'https://store.hp.com/us#commercial'
              "
              value="neither"
            >
              Neither
            </option>
          </select>
        </div>
        <div class="datebox">
          <button @click="refresh" class="btn primarycolor" type="button">Submit</button>
        </div>
      </div>
    </div>
    <div class="container-fluid" style="margin-top: 10px">
      <div class="row card-deck" v-if="isOEM">
        <div :class="getClassSOVSOS()" v-for="(d, i) in websiteSOSGraphs" :key="d.key">
          <div class="space-between-header p-0 m-0" style="align-itmes: center">
            <p style="margin: 0; padding-bottom: 0" class="graphHeading">
              {{ d.title }}
            </p>
            <div
              v-if="sovShowDetailsSiteList.includes(selected_SOVWebsite) && i == 0"
              @click="goToSOVDetail"
              class="sovshowdetails"
            >
              <b-button size="sm" :class="getClassSOVSOSButton()">Show Details</b-button>
            </div>
          </div>
          <highcharts :options="d.chart"></highcharts>
        </div>
      </div>
      <!-- <div class="row " v-if="!isOEM">
          <div :class="showBrand ? 'col-sm-4': 'col-sm-6'" style="padding-right:2px">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV {{ deviceMapper[device] }} Category</p>
              </div>
              <highcharts :options="charts" v-if="activeChart" ></highcharts>
            </div>
          </div>
          <div class="col-md-4" style="padding-left:2px;padding-right:2px" v-if="showBrand">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV {{ deviceMapper[device] }} Search</p>
              </div>
              <highcharts :options="charts_sos" v-if="activeChart" ></highcharts>
            </div>
          </div>
          <div :class="showBrand ? 'col-sm-4': 'col-sm-6'" style="padding-left:2px">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV Position on Page</p>
              </div>
              <highcharts   :options="categorySearchGraph" v-if="activecategorySearchGraph" ></highcharts>
            </div>
          </div>
      </div>     -->
      <div>
        <div v-if="!isOEM">
          <div class="card p-2">
            <div>
              <div class="space-between-header p-0 m-0" style="align-items: center">
                <h4
                  style="max-width: 50%; margin-bottom: 0px !important"
                  class="graphHeading"
                >
                  {{ deviceMapper[device] }} Trends
                </h4>
                <div>
                  <b-button-toolbar
                    class="float-right"
                    aria-label="Toolbar with buttons group"
                  >
                    <b-form-radio-group
                      class="radiohide"
                      id="radiosBtn"
                      buttons
                      button-variant="outline-secondary"
                      v-model="sovInterval"
                      name="radiosBtn"
                    >
                      <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                      <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                      <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                    </b-form-radio-group>
                    <button style="" class="datePickerBadge">From</button>
                    <datepicker
                      placeholder="From"
                      @input="getDailyData"
                      v-model="sovStartDate"
                    />
                    <button class="datePickerBadge">To</button>
                    <datepicker
                      class="picker-left"
                      placeholder="To"
                      @input="getDailyData"
                      v-model="sovEndDate"
                    />
                    <button @click="exportTimelineRetail" class="button exportButton">
                      Export
                    </button>
                  </b-button-toolbar>
                </div>
              </div>
              <div class="borderBetween"></div>
              <div class="">
                <div class="">
                  <h4 class="graphHeading" style="margin-bottom: 0px">
                    SOV trend for {{ deviceMapper[device] }} category page 1
                  </h4>
                </div>
                <div v-if="device == 'gpu'">
                  <lineChart :data="cpuGpuDayWiseChartPage1" />
                </div>
                <div v-else>
                  <highcharts
                    style="width: 100%"
                    :options="daywiseChartPage1"
                  ></highcharts>
                </div>
              </div>
              <div class="borderBetween"></div>
              <div class="">
                <h4 class="graphHeading">
                  SOV trend for {{ deviceMapper[device] }} category pages (1-3)
                </h4>
              </div>
              <div v-if="device == 'gpu'">
                <lineChart :data="cpuGpuDayWiseChart" />
              </div>
              <div v-else>
                <highcharts style="width: 100%" :options="daywiseChart"></highcharts>
              </div>

              <div class="borderBetween"></div>

              <div v-if="selected_SOVWebsite == 'https://global.jd.com'">
                <div class="">
                  <div class="">
                    <h4 class="graphHeading">
                      SOV trend for Gaming {{ deviceMapper[device] }} category pages (1-3)
                    </h4>
                  </div>
                  <highcharts
                    style="width: 100%"
                    :options="daywiseChartGaming"
                  ></highcharts>
                </div>
                <div class="borderBetween"></div>

                <div class="">
                  <div class="">
                    <h4 class="graphHeading">
                      Average SOV trend for {{ deviceMapper[device] }} category pages
                      (1-3)
                    </h4>
                  </div>
                  <highcharts
                    style="width: 100%"
                    :options="daywiseChartAverage"
                  ></highcharts>
                </div>
                <div class="borderBetween"></div>
              </div>
            </div>
            <div>
              <div class="">
                <div class="">
                  <h4 class="graphHeading">
                    SOV Trend for Position On {{ deviceMapper[device] }} category page
                  </h4>
                </div>
                <highcharts
                  style="width: 100%"
                  :options="daywisePositionChart"
                ></highcharts>
              </div>
            </div>
            <div class="borderBetween"></div>

            <div>
              <div class="">
                <div class="">
                  <h4 class="graphHeading">
                    Trend for AMD {{ deviceMapper[device] }} count
                  </h4>
                </div>

                <highcharts style="width: 100%" :options="daywiseAMDCount"></highcharts>
              </div>
              <div v-if="selected_SOVWebsite == 'https://global.jd.com'">
                <div class="">
                  <div class="">
                    <h4 class="graphHeading">
                      Trend for AMD Gaming {{ deviceMapper[device] }} count
                    </h4>
                  </div>
                  <highcharts
                    style="width: 100%"
                    :options="daywiseAMDCountGaming"
                  ></highcharts>
                </div>
                <div class="borderBetween"></div>

                <div class="">
                  <div class="">
                    <h4 class="graphHeading">
                      Average Trend for AMD {{ deviceMapper[device] }} count
                    </h4>
                  </div>
                  <highcharts
                    style="width: 100%"
                    :options="daywiseAMDCountAverage"
                  ></highcharts>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="card p-2">
            <div class="" v-show="daywiseChartOEM.length">
              <div
                class="p-0 m-0"
                style="display: flex; justify-content: space-between; align-items: center"
              >
                <h4 class="graphHeading" style="margin-bottom: 0px !important">
                  Trend for AMD vs Intel {{ deviceMapper[device] }}
                </h4>
                <div>
                  <b-button-toolbar
                    class="float-right"
                    aria-label="Toolbar with buttons group"
                  >
                    <b-form-radio-group
                      class="radiohide"
                      id="radiosBtn"
                      buttons
                      button-variant="outline-secondary"
                      v-model="sovIntervalOEM"
                      name="radiosBtn"
                    >
                      <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                      <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                      <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                    </b-form-radio-group>
                    <button class="datePickerBadge">From</button>
                    <datepicker
                      placeholder="From"
                      @input="getDailyDataOEM"
                      v-model="sovStartDate"
                    />
                    <button class="datePickerBadge">To</button>
                    <datepicker
                      class="picker-left"
                      placeholder="To"
                      @input="getDailyDataOEM"
                      v-model="sovEndDate"
                    />
                    <button @click="exportTimeline" class="button exportButton">
                      Export
                    </button>
                  </b-button-toolbar>
                </div>
              </div>
            </div>
            <div v-for="d in daywiseChartOEM" :key="d.title">
              <div class="borderBetween"></div>

              <div class="">
                <div class="">
                  <h4 class="graphHeading">{{ d.title }}</h4>
                </div>
                <highcharts style="width: 100%" :options="d.chart"></highcharts>
              </div>
              <!-- <div v-if="d.chart != ''" class="borderBetween"></div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <div
          class="card"
          v-if="selected_SOVWebsite != 'all' && priceBandResponse.chart1.length"
        >
          <div class="">
            <div class="">
              <h4 class="graphHeading" style="margin-bottom: 0px !important">
                SOV By Priceband
              </h4>
            </div>
            <div class="borderBetween"></div>
          </div>
          <b-row>
            <div
              :class="{
                mycols:
                  priceBandResponse.chart1.length && priceBandResponse.chart2.length,
              }"
              class="col-md-6"
              style="border-right: 0.12rem solid #e1e1e1 !important"
              v-if="priceBandResponse.chart1.length"
            >
              <div class="">
                <div class="space-between-header">
                  <h4></h4>
                  <div>
                    <b-button-toolbar
                      class="float-right"
                      aria-label="Toolbar with buttons group"
                    >
                      <button class="datePickerBadge">From</button>
                      <datepicker
                        placeholder="From"
                        @input="getPriceBands"
                        v-model="priceBandData.chart1.start_date"
                      />
                      <button class="datePickerBadge">To</button>
                      <datepicker
                        class="picker-left"
                        placeholder="To"
                        @input="getPriceBands"
                        v-model="priceBandData.chart1.end_date"
                      />
                    </b-button-toolbar>
                  </div>
                </div>
                <highcharts
                  style="width: 100%"
                  :options="priceBandData.chart1.data"
                ></highcharts>
              </div>
            </div>
            <div
              :class="{
                mycols:
                  priceBandResponse.chart1.length && priceBandResponse.chart2.length,
              }"
              class="col-md-6 mycols"
              v-if="priceBandResponse.chart2.length"
            >
              <div class="">
                <div class="space-between-header">
                  <h4></h4>
                  <div>
                    <b-button-toolbar
                      class="float-right"
                      aria-label="Toolbar with buttons group"
                    >
                      <button class="datePickerBadge">From</button>
                      <datepicker
                        placeholder="From"
                        @input="getPriceBands"
                        v-model="priceBandData.chart2.start_date"
                      />
                      <button class="datePickerBadge">To</button>
                      <datepicker
                        class="picker-left"
                        placeholder="To"
                        @input="getPriceBands"
                        v-model="priceBandData.chart2.end_date"
                      />
                    </b-button-toolbar>
                  </div>
                </div>
                <highcharts
                  style="width: 100%"
                  :options="priceBandData.chart2.data"
                ></highcharts>
              </div>
            </div>
          </b-row>
          <div v-if="!isOEM" class="borderBetween"></div>
          <div v-if="!isOEM">
            <div>
              <div
                class="m-0 p-0 space-between-header"
                style="align-items: center !important"
              >
                <h4 class="graphHeading" style="margin-bottom: 0px !important">
                  {{ device === "gpu" ? "GPU" : "Processor" }} SOV by Priceband
                </h4>

                <div style="display: flex !important">
                  <!-- <b-button-toolbar
                class="float-left"
                aria-label="Toolbar with buttons group"
              > -->
                  <button class="datePickerBadge">From</button>
                  <datepicker
                    placeholder="From"
                    @input="priceBandsProcessor"
                    v-model="pbpStartDate"
                  />
                  <button class="datePickerBadge">To</button>
                  <datepicker
                    class="picker-left"
                    placeholder="To"
                    @input="priceBandsProcessor"
                    v-model="pbpEndDate"
                  />
                  <!-- </b-button-toolbar> -->

                  <button class="datePickerBadge">Pages</button>
                  <select
                    @change="priceBandsProcessor"
                    v-model="pbpPage"
                    class="form-control text-uppercase"
                  >
                    <option value="1-3">1-3</option>
                    <option value="1">1</option>
                    <option v-if="isPrice" value="all">All</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              class="mt-3"
              v-for="c in priceBandsProcessorGraphs"
              :key="'pbpc_' + c.title"
            >
              <highcharts style="width: 100%" :options="c.chart"></highcharts>
            </div>
          </div>
        </div>
      </div>
      <div v-show="pieSeriesData != ''">
        <div class="card">
          <div class="">
            <div class="space-between-header m-0 p-0" style="align-items: center">
              <h4 class="graphHeading" style="margin-bottom: 0px !important">
                {{ deviceMapper[device] }} Category Data
              </h4>
              <div style="display: flex">
                <button class="datePickerBadge">Pages:</button>
                <select
                  @change="readyPie"
                  v-model="selectedPage"
                  class="form-control text-uppercase"
                >
                  <option value="1-3">1-3</option>
                  <option value="1">1</option>
                </select>
              </div>
            </div>
            <div class="borderBetween"></div>
          </div>
          <div class="" v-if="!isOEM">
            <h4 style="display: inline-block" class="graphHeading">All Listing</h4>
            <div>
              <span
                style="
                  font-size: 13px;
                  margin-bottom: -17px;
                  font-weight: 600;
                  z-index: 9;
                  color: #47a694;
                "
                >Total {{ deviceMapper[device] }}: {{ pieTotalAll }}</span
              >
              <div v-if="!isOEM">
                <highcharts
                  style="width: 100%; margin-top: -20px"
                  v-if="activePie"
                  :options="pieChartAMDTotal"
                >
                </highcharts>
              </div>
            </div>
            <div class="borderBetween"></div>
          </div>
          <div class="">
            <div class="">
              <div class="space-between-header p-0" style="align-items: center">
                <h4
                  style="display: inline-block; margin-bottom: 0px !important"
                  class="graphHeading"
                >
                  AMD Listing
                </h4>
                <div style="display: flex">
                  <select
                    class="form-control text-uppercase"
                    style="float: right; width: 170px; border: 1px solid #c5c5c5"
                    v-model="amdCPUFilter"
                    @change="readyPie"
                    v-if="!(device == 'cpu' || device == 'gpu')"
                  >
                    <option value="all">All AMD {{ deviceMapper[device] }}</option>
                    <option value="ryzen">Ryzen {{ deviceMapper[device] }}</option>
                    <option value="non_ryzen">
                      Non-Ryzen {{ deviceMapper[device] }}
                    </option>
                  </select>
                  <div @click="goToDetailPage" class="ml-2">
                    <b-button size="sm" class="navigationButton">Show Details</b-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                :class="showBrandHP ? 'col-sm-6 mycols borderRight ' : 'col-sm-12 mycol'"
                v-for="(d, i) in labelMapper"
                :key="i"
              >
                <div class="">
                  <span
                    style="
                      font-size: 13px;
                      margin-bottom: -15px;
                      font-weight: 600;
                      z-index: 9;
                      color: #47a694;
                    "
                  >
                    <span v-if="amdCPUFilter == 'all'"
                      >Total AMD {{ deviceMapper[device] }}:
                    </span>
                    <span v-if="amdCPUFilter == 'ryzen'"
                      >Total Ryzen {{ deviceMapper[device] }}:
                    </span>
                    <span v-if="amdCPUFilter == 'non_ryzen'"
                      >Total Non-Ryzen {{ deviceMapper[device] }}:
                    </span>
                    {{ pieTotal }}</span
                  >
                  <highcharts
                    style="width: 100%; margin-top: -20px"
                    v-if="activePie"
                    :options="pieChartAMD[i]"
                  >
                  </highcharts>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="websitesUrls3.hasOwnProperty(selected_SOVWebsite)">
        <div class="card" v-if="isOEM || selectedWebComplianceScore">
          <div
            v-if="isOEM"
            v-for="(d, idx) in complianceTrend"
            :key="'complianceTrend' + d.id + '_' + idx"
          >
            <div class="">
              <div class="space-between-header m-0 p-0" style="align-items: center">
                <h4 class="graphHeading" style="margin-bottom: 0px !important">
                  Trend For Compliance Score
                </h4>
                <b-button-toolbar
                  class="float-right"
                  aria-label="Toolbar with buttons group"
                >
                  <button class="datePickerBadge">From</button>
                  <datepicker
                    placeholder="From"
                    @input="getComplianceTrend"
                    v-model="comTrendStartDate"
                  />
                  <button class="datePickerBadge">To</button>
                  <datepicker
                    class="picker-left"
                    placeholder="To"
                    @input="getComplianceTrend"
                    v-model="comTrendEndDate"
                  />
                </b-button-toolbar>
              </div>
              <lineChart :data="d" />
            </div>
          </div>
          <div class="borderBetween" v-if="complianceTrend != ''"></div>
          <div v-if="selectedWebComplianceScore != ''">
            <div class="">
              <div style="display: flex; justify-content: space-between">
                <div>
                  <h4 class="graphHeading">Compliance Score</h4>
                  <h5
                    style="
                      line-height: 36px;
                      margin-top: 20px;
                      font-size: 13px;
                      font-weight: 600;
                      z-index: 9;
                      color: #47a694;
                    "
                  >
                    {{ websitesUrls3[selected_SOVWebsite] }}:
                    <span>{{ selectedWebComplianceScore }}</span>
                  </h5>
                </div>
                <div @click="goToCompliance" class="">
                  <b-button size="sm" class="navigationButton">Show Details</b-button>
                </div>
              </div>
              <highcharts :options="comChart" v-if="activeComChart"></highcharts>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!errorInProduct">
        <div class="card">
          <div>
            <div class="">
              <div class="space-between-header p-0 m-0">
                <h3></h3>
                <div style="display: inherit">
                  <div
                    v-if="
                      selected_SOVWebsite == 'https://www.bestbuy.com' ||
                      selected_SOVWebsite == 'https://www.amazon.com' ||
                      selected_SOVWebsite == 'https://www.amazon.fr' ||
                      selected_SOVWebsite == 'https://www.amazon.co.it' ||
                      selected_SOVWebsite == 'https://www.amazon.es' ||
                      selected_SOVWebsite == 'https://www.amazon.co.uk' ||
                      selected_SOVWebsite == 'https://www.amazon.de'
                    "
                    style="display: flex; cursor: pointer; margin-right: 4px"
                  >
                    <div class="checkbox-btn">
                      <input
                        v-model="sponCheck"
                        style="float: left; margin-right: 6px; margin-top: 3px"
                        type="checkbox"
                      />
                      <span> Sponsored </span>
                    </div>
                  </div>
                  <div @click="showProductModal" style="display: flex; cursor: pointer">
                    <div
                      style="
                        height: 35px;
                        border: none;
                        background: var(--primary_brand);
                        color: white;
                        border-radius: 5px;
                        font-weight: 600;
                        padding: 0px 25px;
                        display: flex;
                        align-items: center;
                        letter-spacing: 0.2px;
                      "
                    >
                      Products
                    </div>
                    <div
                      style="
                        background: white;
                        padding-left: 14px;
                        border: 1px solid var(--primary_brand);
                        border-radius: 5px;
                        margin-left: -5px;
                        padding-right: 14px;
                      "
                    >
                      <span
                        style="
                          margin-top: 7px;
                          float: left;
                          font-size: 12px;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          max-width: 201px;
                        "
                        >{{ allReviewProductsCheck ? "All" : selectedProduct[0] }}</span
                      >
                      <i
                        style="padding-top: 7px; font-size: 17px; margin-left: 12px"
                        class="fa fa-angle-down"
                      ></i>
                    </div>
                    <!-- <select @change="refreshReview" v-model="selectedProduct" class="form-control text-uppercase">  
                  <option value="all">All</option>           
                  <option v-for="(d,i) in productOptions" :key="i" :value="d">{{d}}</option>
                </select> -->
                  </div>

                  <div class="datePickerBadge" style="padding-left: 6px">From</div>
                  <datepicker
                    placeholder="From"
                    @input="refreshReview"
                    v-model="reviewStartDate"
                  />
                  <div class="datePickerBadge" style="padding-left: 6px">To</div>
                  <datepicker
                    v-model="reviewEndDate"
                    class="picker-left"
                    placeholder="To"
                    @input="refreshReview"
                  />
                  <div @click="goToSenti" style="margin-left: 6px">
                    <b-button size="sm" class="navigationButton">Show Reviews</b-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="borderBetween"></div>
            <div class="">
              <div class="space-between-header">
                <h4 class="graphHeading">
                  Total Reviews: {{ totalReviewCount | format }}
                </h4>
                <div>
                  <b-button-toolbar
                    class="float-right"
                    aria-label="Toolbar with buttons group"
                  >
                    <b-form-radio-group
                      class="radiohide"
                      id="radiosBtn"
                      buttons
                      button-variant="outline-secondary"
                      v-model="revInterval"
                      name="radiosBtn"
                    >
                      <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                      <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                      <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                    </b-form-radio-group>
                  </b-button-toolbar>
                </div>
              </div>
              <highcharts :options="reviewGraph" v-if="activeReviewGraph"></highcharts>
              <div style="margin: 15px"></div>
              <highcharts :options="creviewGraph" v-if="activeReviewGraph"></highcharts>
            </div>
            <div class="borderBetween"></div>

            <div class="">
              <div class="space-between-header" style="align-items: center">
                <h4 class="graphHeading" style="margin-bottom: 20px !important">
                  Avg. Rating: {{ ratingAvg }}
                </h4>
                <div style="display: flex">
                  <b-button-toolbar aria-label="Toolbar with buttons group">
                    <b-form-radio-group
                      class="radiohide"
                      id="radiosBtn"
                      buttons
                      button-variant="outline-secondary"
                      v-model="revInterval"
                      name="radiosBtn"
                    >
                      <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                      <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                      <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                    </b-form-radio-group>
                  </b-button-toolbar>
                </div>
              </div>
              <highcharts :options="ratingGraph" v-if="activeRatingGraph"></highcharts>
              <div style="margin: 15px"></div>
              <highcharts :options="cratingGraph" v-if="activeReviewGraph"></highcharts>
              <p
                style="
                  text-align: center;
                  font-size: 12px;
                  font-weight: 600;
                  color: var(--primary_brand);
                  text-transform: initial;
                "
              >
                Cumulative Rating = Cumulative Sum of Ratings / Cumulative Sum of Reviews
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      size="lg"
      title="Select Product"
      v-model="isProductModal"
      class="customModal"
    >
      <b-row>
        <div class="col-md-12">
          <div style="display: flex" class="searchInput">
            <input
              style="border-radius: 0; padding: 6px; font-size: 11px"
              class="form-control"
              v-model="schProduct"
              type="text"
              placeholder="Search"
            />
            <div class="searchIcon">
              <img src="/img/Search.4045f20d.svg" />
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="pt-2" v-if="checkChannel()">
        <div class="col-md-2 mb-1">
          <p class="mt-1 inputBoxTitle">OEM:</p>
        </div>
        <div class="customMultiselect col-md-10">
          <multiselect
            v-model="checkedOemReviewsBrands"
            :options="
              filterKeys.brand.map((data) => {
                return { label: data };
              })
            "
            :multiple="true"
            :searchable="false"
            placeholder="Select Brands"
            label="label"
            track-by="label"
            selectLabel=""
            @input="changeFilter"
          />
        </div>
      </b-row>
      <b-row class="pt-2">
        <div class="col-md-2 mt-1">
          <p class="mt-1 inputBoxTitle">Processor:</p>
        </div>
        <div class="customMultiselect col-md-10">
          <multiselect
            v-model="checkedReviewsProcessors"
            :options="
              filterKeys.processor_type.map((data) => {
                return { label: data };
              })
            "
            :multiple="true"
            :searchable="false"
            placeholder="Select Processors"
            label="label"
            track-by="label"
            selectLabel=""
            @input="changeFilter"
          />
        </div>
      </b-row>
      <b-row class="pt-2">
        <div class="col-md-2">
          <p class="mt-1 inputBoxTitle">Ratings:</p>
        </div>
        <div class="ratingSection col-md-10">
          <div class="ratingSectionItem mr-1">
            <select v-model="ratingExp" class="form-control text-uppercase">
              <option value="eq">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="pl-0 mx-1 ratingSectionItem">
            <input
              min="0"
              max="5"
              v-model="ratingInput1"
              style="border: 1px solid silver !important"
              class="form-control filval"
              type="number"
              placeholder="Enter Value"
            />
          </div>
          <div v-if="ratingExp == 'between'" class="mx-1 ratingSectionItem">
            <input
              min="0"
              max="5"
              v-model="ratingInput2"
              style="border: 1px solid silver !important"
              class="form-control filval"
              type="number"
              placeholder="Enter Value"
            />
          </div>
          <div class="pl-1">
            <button @click="applyRatingFilter" class="btn primarycolor mx-1">
              Apply
            </button>
            <button
              @click="removeRatingFilter"
              class="btn primarycolor mx-1"
              style="background-color: var(--red)"
            >
              Remove
            </button>
          </div>
        </div>
      </b-row>
      <b-row style="margin-top: 15px; padding-right: 20px">
        <div class="col-md-3 pr-0">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="fourKSeries" type="checkbox" />
            <span>4000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pr-0 pl-1">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="fiveKSeries" type="checkbox" />
            <span>5000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pr-0 pl-1">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="sixKSeries" type="checkbox" />
            <span>6000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pr-0 pl-1">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="sevenSeries" type="checkbox" />
            <span>7000 Series</span>
          </div>
        </div>
      </b-row>

      <div class="space-between-header" style="padding-top: 20px; align-items: center">
        <h5 class="m-0 graphHeading" style="margin-bottom: 0px !important">Products:</h5>
        <button
          class="btn primarycolor"
          style="padding: 2px 20px"
          @click="selectProductNow()"
        >
          Apply
        </button>
      </div>
      <div class="productScroll">
        <div class="eachProduct productListCheckbox" style="padding: 4px">
          <input
            type="checkbox"
            class="mr-1"
            value="all"
            @click="processAllProductChecking($event)"
            v-model="allReviewProductsCheck"
          />
          <span>All</span>
        </div>
        <div
          :class="{ selectedProduct: selectedProduct.key == d.key }"
          class="eachProduct productListCheckbox"
          style="padding: 4px"
          :key="d.key"
          v-for="d in productOptions"
        >
          <input
            type="checkbox"
            class="mr-1"
            :value="d.key"
            @click="processProductChecking($event)"
            :checked="
              allReviewProductsCheck ? true : checkedReviewsProducts.includes(d.key)
            "
          />
          <span>{{ d.key }}</span>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import lineChart from "./commonCharts/lineChart.vue";
import Multiselect from "vue-multiselect";
import Loader from "./Components/Loader.vue";

export default {
  name: "sov",
  components: { Datepicker, lineChart, Multiselect, Loader },
  data: function () {
    if (localStorage.selected_SOVWebsite)
      this.selected_SOVWebsite = localStorage.selected_SOVWebsite;
    else this.selected_SOVWebsite = "https://www.bestbuy.com";
    if (localStorage.selected_category)
      this.selected_category = localStorage.selected_category;
    else this.selected_category = "laptop";
    return {
      selected_SOVWebsite: this.selected_SOVWebsite,
      date: {
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      },
      websitesUrls: {
        "https://www.amazon.com": "amazon_US",
        "https://www.amazon.fr": "amazon_france",
        "https://www.newegg.com": "newegg",
        "https://www.microcenter.com": "microcenter",
        "https://www.amazon.co.it": "amazon_italy",
        "https://www.amazon.es": "amazon_spain",
        "https://www.amazon.co.uk": "amazon_uk",
        "https://www.amazon.de": "amazon_germany",
        "https://www.harveynorman.com.au": "harvey",
        "https://www.bestbuy.com": "BESTBUY",
        "https://www.currys.co.uk": "currys_uk",
        "https://www.costco.com": "costco",
        "https://www.walmart.com": "walmart",
        "https://store.hp.com/us": "hp",
        "https://store.hp.com/UKStore": "hp_uk",
        "https://global.jd.com": "jd",
        "https://store.asus.com/us": "asus",
        "https://www.asus.com/fr": "asus_france",
        "https://www.dell.com/en-us": "dell",
        "https://www.dell.com/en-uk": "dell_uk",
        "https://store.acer.com/en-us": "Acer",
        "https://www.lenovo.com/us": "lenovo",
        "https://www.lenovo.com/gb": "lenovo_uk",
        "https://www.lenovo.com/de": "lenovo_germany",
        "https://www.mediamarkt.de": "mediamarkt",
        "https://store.hp.com/us#commercial": "hp_commercial",
        "https://www.lenovo.com/us#commercial": "lenovo_commercial",
        "https://www.lenovo.com/de#commercial": "lenovo_germany_commercial",
        "https://store.hp.com/GermanyStore#commercial": "hp_germany",
        "https://www8.hp.com/jp#commercial": "hp_japan_commercial",
        "https://store.hp.com/UKStore#commercial": "hp_uk_commercial",
        "https://www.lenovo.com/gb#commercial": "lenovo_uk_commercial",
        "https://www8.hp.com/jp": "hp_japan",
        "https://www.cdw.com": "cdw",
        "https://www.insight.com/en-US": "insight",
        "https://www.lenovo.com/fr#commercial": "lenovo_france_commercial",
        "https://store.hp.com/FranceStore#commercial": "hp_france_commercial",
        "https://www.lenovo.com/fr": "lenovo_france",
        "https://store.hp.com/mx-es": "hp_mexico",
        "https://store.hp.com/FranceStore": "hp_france",
        "https://s.lenovo.com.cn": "lenovo_gc",
        "https://br-store.acer.com": "acer_brazil",
        "https://www.lenovo.com/au": "lenovo_australia",
        "https://www.dell.com/en-au": "dell_australia",
        "https://www.dell.com/ja-jp": "dell_japan",
        "https://fmv.fccl.fujitsu.com": "fujitsu",
        "https://www.nec-lavie.jp": "nec",
        "https://www.hpstore.cn#commercial": "hp_china_commercial",
        "https://www.lenovo.com/jp#commercial": "lenovo_japan_commercial",
        "https://b2b.lenovo.com.cn#commercial": "lenovo_china_commercial",
        "https://www.shi.com": "shi_commercial",
        "https://www.connection.com": "PC Connection",
        "https://www.dustin.no": "Dustin Nordics Norway",
        "https://www.dustin.se": "Dustin Nordics Sweden",
        "https://www.dustin.fi": "Dustin Nordics Finland",
        "https://www.dustin.dk": "Dustin Nordics Denmark",
        "https://www.bechtle.com": "Bechtle",
        "https://www.technoworld.com": "technoworld",
        "https://www.inmac-wstore.com": "inmac",
        "https://www.asus.com": "asus_ww",
      },
      websitesUrls3: {
        all: "All",
        "https://www.amazon.com": "amazon",
        "https://www.amazon.fr": "Amazon France",
        "https://www.amazon.co.it": "Amazon Italy",
        "https://www.amazon.es": "Amazon Spain",
        "https://www.amazon.co.uk": "Amazon Uk",
        "https://www.amazon.de": "Amazon Germany",
        "https://www.harveynorman.com.au": "harvey norman",
        "https://www.bestbuy.com": "bestbuy",
        "https://www.currys.co.uk": "Curry's",
        "https://www.costco.com": "costco",
        "https://www.walmart.com": "walmart",
        "https://store.hp.com/us": "HP US",
        "https://global.jd.com": "JD",
        "https://store.asus.com/us": "ASUS",
        "https://www.dell.com/en-us": "Dell",
        "https://www.dell.com/en-uk": "Dell UK",
        "https://store.hp.com/mx-es": "HP Mexico",
        "https://store.hp.com/FranceStore": "HP France",
        "https://br-store.acer.com": "Acer Brazil",
        "https://www.lenovo.com/au": "Lenovo Australia",
        "https://s.lenovo.com.cn": "Lenovo China",
        "https://www.asus.com/fr": "Asus France",
        "https://www.dell.com/en-au": "Dell Australia",
        "https://www.dell.com/ja-jp": "Dell Japan",
        "https://fmv.fccl.fujitsu.com": "Fujitsu Japan",
        "https://www.nec-lavie.jp": "NEC Japan",
        "https://www.hpstore.cn#commercial": "Commercial HP China",
        "https://www.lenovo.com/jp#commercial": "Commercial Lenovo Japan",
        "https://b2b.lenovo.com.cn#commercial": "Commercial Lenovo China",
        "https://www8.hp.com/jp#commercial": "Commercial HP Japan",
        "https://www.shi.com": "SHI",
        "https://www.connection.com": "PC Connection",
        "https://www.dustin.no": "Dustin Nordics Norway",
        "https://www.dustin.se": "Dustin Nordics Sweden",
        "https://www.dustin.fi": "Dustin Nordics Finland",
        "https://www.dustin.dk": "Dustin Nordics Denmark",
        "https://www.bechtle.com": "Bechtle",
        "https://www.technoworld.com": "TechnoWorld",
        "https://www.inmac-wstore.com": "Inmac",
        "https://www.asus.com": "ASUS WW",
        "https://store.acer.com/en-us": "Acer",
        "https://store.hp.com/UKStore": "HP UK",
        "https://www8.hp.com/jp": "HP Japan",
        "https://www.lenovo.com/us": "Lenovo US",
        "https://www.lenovo.com/gb": "Lenovo UK",
        "https://www.lenovo.com/de": "Lenovo Germany",
        "https://www.mediamarkt.de": "MediaMarkt",
        "https://store.hp.com/us#commercial": "Commercial HP US",
        "https://www.lenovo.com/us#commercial": "Commercial Lenovo US",
        "https://www.lenovo.com/de#commercial": "Commercial Lenovo Germany ",
        "https://store.hp.com/GermanyStore#commercial": "Commercial HP Germany",
        "https://www.cdw.com": "CDW",
        "https://www.insight.com/en-US": "Insight",
        "https://www.lenovo.com/fr#commercial": "Commercial Lenovo France",
        "https://store.hp.com/FranceStore#commercial": "Commercial HP France",
        "https://store.hp.com/UKStore#commercial": "Commercial HP UK",
        "https://www.lenovo.com/gb#commercial": "Commercial Lenovo UK",
        "https://www.lenovo.com/fr": "Lenovo France",
        "https://www.dell.com/en-uk": "Dell UK",
        "https://www.newegg.com": "newegg",
        "https://www.microcenter.com": "microcenter",
      },
      websitesPriceMap: {
        "https://www.amazon.com": "$",
        "https://www.amazon.fr": "€",
        "https://www.amazon.co.it": "€",
        "https://www.amazon.es": "€",
        "https://www.amazon.co.uk": "£",
        "https://www.amazon.de": "€",
        "https://www.harveynorman.com.au": "$",
        "https://www.bestbuy.com": "$",
        "https://www.currys.co.uk": "£",
        "https://www.costco.com": "$",
        "https://www.walmart.com": "$",
        "https://store.hp.com/us": "$",
        "https://store.hp.com/UKStore": "£",
        "https://global.jd.com": "¥",
        "https://store.asus.com/us": "$",
        "https://www.dell.com/en-us": "$",
        "https://www.dell.com/en-uk": "$",
        "https://store.acer.com/en-us": "$",
        "https://www.lenovo.com/us": "$",
        "https://www.lenovo.com/gb": "£",
        "https://www.lenovo.com/de": "€",
        "https://www.mediamarkt.de": "€",
        "https://www8.hp.com/jp": "¥",
        "https://www.lenovo.com/de#commercial": "€",
        "https://store.hp.com/us#commercial": "$",
        "https://store.hp.com/GermanyStore#commercial": "€",
        "https://www.lenovo.com/us#commercial": "$",
        "https://store.hp.com/UKStore#commercial": "£",
        "https://www.lenovo.com/gb#commercial": "£",
        "https://www.cdw.com": "$",
        "https://www.insight.com/en-US": "$",
        "https://www.lenovo.com/fr#commercial": "€",
        "https://store.hp.com/FranceStore#commercial": "€",
        "https://www.lenovo.com/fr": "€",
        "https://store.hp.com/mx-es": "$",
        "https://store.hp.com/FranceStore": "€",
        "https://www.asus.com/fr": "€",
        "https://s.lenovo.com.cn": "¥",
        "https://br-store.acer.com": "R$",
        "https://www.lenovo.com/au": "$",
        "https://www.dell.com/ja-jp": "¥",
        "https://www.dell.com/en-au": "$",
        "https://www.hpstore.cn#commercial": "¥",
        "https://fmv.fccl.fujitsu.com": "円",
        "https://www.nec-lavie.jp": "円",
        "https://www8.hp.com/jp#commercial": "￥",
        "https://b2b.lenovo.com.cn#commercial": "¥",
        "https://www.lenovo.com/jp#commercial": "¥",
        "https://www.shi.com": "$",
        "https://www.connection.com": "$",
        "https://www.bechtle.com": "€",
        "https://www.technoworld.com": "£",
        "https://www.inmac-wstore.com": "€",
        "https://www.microcenter.com": "$",
        "https://www.newegg.com": "$",
      },
      oem_websites: [
        "https://www.inmac-wstore.com",
        "https://www.technoworld.com",
        "https://www.asus.com",
        "https://www.bechtle.com",
        "https://www.connection.com",
        "https://www.dustin.no",
        "https://www.dustin.se",
        "https://www.dustin.fi",
        "https://www.dustin.dk",
        "https://www.shi.com",
        "https://www8.hp.com/jp#commercial",
        "https://www.lenovo.com/jp#commercial",
        "https://b2b.lenovo.com.cn#commercial",
        "https://www.hpstore.cn#commercial",
        "https://www.nec-lavie.jp",
        "https://fmv.fccl.fujitsu.com",
        "https://www.dell.com/ja-jp",
        "https://www.dell.com/en-au",
        "https://www.lenovo.com/au",
        "https://br-store.acer.com",
        "https://s.lenovo.com.cn",
        "https://store.hp.com/FranceStore",
        "https://store.hp.com/mx-es",
        "https://www.lenovo.com/fr",
        "https://www.insight.com/en-US",
        "https://store.hp.com/FranceStore#commercial",
        "https://www.lenovo.com/fr#commercial",
        "https://www.cdw.com",
        "https://www.lenovo.com/gb#commercial",
        "https://store.hp.com/UKStore#commercial",
        "https://www.lenovo.com/de#commercial",
        "https://store.hp.com/GermanyStore#commercial",
        "https://www8.hp.com/jp",
        "https://store.hp.com/us#commercial",
        "https://www.lenovo.com/us#commercial",
        "https://store.hp.com/UKStore",
        "https://store.hp.com/us",
        "https://www.asus.com/fr",
        "https://store.asus.com/us",
        "https://www.dell.com/en-us",
        "https://www.dell.com/en-uk",
        "https://store.acer.com/en-us",
        "https://www.lenovo.com/us",
        "https://www.lenovo.com/gb",
        "https://www.lenovo.com/de",
      ],
      columns: [
        { label: "Brand", field: "brand", sortable: false },
        { label: "Sub Brand", field: "sub_brand", sortable: false },
        { label: "Form Factor", field: "form_factor", sortable: false },
        { label: "Page 1 System Count", field: "page_1_system_count" },
        { label: "Page Count (page 1)", field: "page_1_count" },
        { label: "Page 1 SOV", field: "page_1_sov" },

        { label: "Pages 1-3 System Count", field: "page_1_3_system_count" },
        { label: "Pages Count (1-3)", field: "page_1_3_count" },
        { label: "Pages 1-3 SOV", field: "page_1_3_sov" },

        { label: "All Pages System Count", field: "page_all_system_count" },
        { label: "All Pages Count", field: "page_all_count" },
        { label: "All Pages SOV", field: "page_all_sov" },
      ],
      rows: [],
      sos_rows: [],
      rows_details: [],
      page: 1,
      charts: {},
      charts_sos: {},
      activeChart: false,
      labelMapper: {
        brand: "Brand",
        processor_type: "Processor",
        // 'gpu_type': 'GPU'
      },
      isProductModal: false,
      countAMD: {},
      pieChartAMD: {},
      barGraph: {},
      activePie: false,
      activeBarChart: false,
      selectedPage: "1-3",
      loader: true,
      pageDistributionData: {},
      sovSOSGraph: {},
      activesovSOSGraph: true,
      categorySearchGraph: {},
      activecategorySearchGraph: true,
      colorShades: {
        red: [
          "#f56464",
          "#fb7878",
          "#fb9178",
          "#fbc778",
          "#f57264",
          "#f56485",
          "#f56492",
        ],
        blue: [
          "#7887fb",
          "#788dfb",
          "#78a6fb",
          "#78b2fb",
          "#78d0fb",
          "#78d6fb",
          "#78c4fb",
        ],
        green: [
          "#9af575",
          "#87d866",
          "#80f564",
          "#9bf564",
          "#64f591",
          "#64f570",
          "#71b755",
        ],
      },
      index: {
        red: 0,
        blue: 0,
        green: 0,
      },
      daywiseChart: {},
      daywiseChartPage1: {},
      dailyData: [],
      daywiseChartOEM: {},

      amdCPUFilter: "all",
      pieTotal: "",
      pieTotalAll: "",
      comChart: {},
      activeComChart: false,
      selectedProduct: {},
      productOptions: [],
      productOptionsFull: [],
      reviewStartDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
      reviewEndDate: moment().format("YYYY-MM-DD"),
      reviewGraph: {},
      creviewGraph: {},
      activeReviewGraph: false,
      ratingGraph: {},
      cratingGraph: {},
      activeRatingGraph: false,
      totalReviewCount: "",
      ratingAvg: "",
      reviewStarData: {},
      sentimentData: {},
      sentimentChart: {},
      showBrand: true,
      showBrandHP: true,
      isOEM: false,
      activeSentimentChart: false,
      sovInterval: "day",
      sovIntervalOEM: "day",
      sovStartDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
      sovEndDate: moment().format("YYYY-MM-DD"),
      comTrendStartDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      comTrendEndDate: moment().format("YYYY-MM-DD"),
      revInterval: "week",
      selectedWebComplianceScore: "",
      brand_list: [],
      gpu_list: [],
      schProduct: "",
      deviceMapper: {
        laptop: "Laptop",
        desktop: "Desktop",
        neither: "Neither",
        cpu: "CPU",
        gpu: "GPU",
      },
      device: this.selected_category,
      cpuFilter: "",
      brandFilter: "",
      filterKeys: {
        brand: [],
        processor_type: [],
      },
      websiteSOSGraphs: [],
      cpuGpuDayWiseChart: [],
      cpuGpuDayWiseChartPage1: [],
      errorInProduct: false,
      loader4: false,
      daywisePositionChart: {},
      daywiseAMDCount: {},
      sponCheck: false,
      ratingInput1: "",
      ratingExp: "eq",
      ratingInput2: "",
      pickProduct: false,
      priceBandData: {
        chart1: {
          start_date: moment().subtract(7, "days").format("YYYY-MM-DD"),
          end_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
          data: {},
        },
        chart2: {
          start_date: moment().subtract(14, "days").format("YYYY-MM-DD"),
          end_date: moment().subtract(8, "days").format("YYYY-MM-DD"),
          data: {},
        },
      },
      priceBandResponse: {
        chart1: [],
        chart2: [],
      },
      sovShowDetailsSiteList: [
        "https://store.hp.com/UKStore",
        "https://www.lenovo.com/fr",
        "https://www.lenovo.com/de",
        "https://www.lenovo.com/gb",
        "https://www.lenovo.com/us",
        "https://store.acer.com/en-us",
        "https://store.asus.com/us",
        "https://www.asus.com/fr",
        "https://store.hp.com/us",
        "https://www.dell.com/en-us",
        "https://www.dell.com/en-uk",
        "https://www8.hp.com/jp",
        "https://s.lenovo.com.cn",
        "https://br-store.acer.com",
        "https://store.hp.com/FranceStore",
        "https://store.hp.com/mx-es",
        "https://www.dell.com/ja-jp",
        "https://www.dell.com/en-au",
        "https://www.lenovo.com/au",
        "https://fmv.fccl.fujitsu.com",
        "https://www.nec-lavie.jp",
        "https://b2b.lenovo.com.cn#commercial",
        "https://store.hp.com/UKStore#commercial",
        "https://store.hp.com/GermanyStore#commercial",
        "https://store.hp.com/FranceStore#commercial",
        "https://www.cdw.com",
        "https://www.lenovo.com/de#commercial",
        "https://www.lenovo.com/us#commercial",
        "https://www.lenovo.com/gb#commercial",
        "https://www.lenovo.com/jp#commercial",
        "https://www.hpstore.cn#commercial",
        "https://www.insight.com/en-US",
        "https://store.hp.com/us#commercial",
        "https://www.lenovo.com/fr#commercial",
        "https://www8.hp.com/jp#commercial",
        "https://www.shi.com",
        "https://www.connection.com",
        "https://www.bechtle.com",
        "https://www.inmac-wstore.com",
        "https://www.technoworld.com",
        "https://www.dustin.no",
        "https://www.dustin.se",
        "https://www.dustin.fi",
        "https://www.dustin.dk",
      ],
      pieSeriesData: [],
      commercialSites: [
        "https://www.inmac-wstore.com",
        "https://www.technoworld.com",
        "https://www.bechtle.com",
        "https://www.connection.com",
        "https://www.shi.com",
        "https://www8.hp.com/jp#commercial",
        "https://www.lenovo.com/jp#commercial",
        "https://b2b.lenovo.com.cn#commercial",
        "https://www.hpstore.cn#commercial",
        "https://www.insight.com/en-US",
        "https://store.hp.com/FranceStore#commercial",
        "https://www.lenovo.com/fr#commercial",
        "https://www.cdw.com",
        "https://www.lenovo.com/gb#commercial",
        "https://store.hp.com/UKStore#commercial",
        "https://www.lenovo.com/us#commercial",
        "https://www.lenovo.com/de#commercial",
        "https://store.hp.com/GermanyStore#commercial",
        "https://store.hp.com/us#commercial",
      ],
      fourKSeries: false,
      fiveKSeries: false,
      sixKSeries: false,
      sevenSeries: false,
      dailyDataPage1: [],
      dailyDataGamingPage13: [],
      dailyDataAveragePage13: [],
      daywiseAMDCountAverage: {},
      daywiseAMDCountGaming: {},
      daywiseChartAverage: {},
      daywiseChartGaming: {},
      complianceTrend: [],
      priceBandsProcessorGraphs: [],
      pbpPage: "1-3",
      pbpStartDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      pbpEndDate: moment().format("YYYY-MM-DD"),
      allProcessorData: [],
      page1ProcessorData: [],
      price_sites: [
        "https://www.bestbuy.com",
        "https://www.currys.co.uk",
        "https://www.harveynorman.com.au",
        "https://www.mediamarkt.de",
        "https://www.walmart.com",
        "https://www.amazon.com",
        "https://www.amazon.fr",
        "https://www.amazon.co.it",
        "https://www.amazon.es",
        "https://www.amazon.co.uk",
        "https://www.amazon.de",
        "https://www.costco.com",
        "https://global.jd.com",
        "https://www.newegg.com",
        "https://www.microcenter.com",
      ],
      cpuGpuSites: [
        "https://www.amazon.com",
        "https://www.microcenter.com",
        "https://www.newegg.com",
        "https://www.bestbuy.com",
      ],
      isPrice: false,
      checkedReviewsProcessors: [],
      checkedOemReviewsBrands: [],
      checkedReviewsProducts: [],
      allReviewProductsCheck: true,
    };
  },
  watch: {
    sponCheck: function () {
      this.getReviews();
    },
    sovInterval: function () {
      this.getDailyData();
    },
    sovIntervalOEM: function () {
      let self = this;
      setTimeout(function () {
        self.getDailyDataOEM();
      });
    },
    revInterval: function () {
      if (this.selectedProduct) this.getReviews();
    },
  },
  mounted() {
    if (localStorage.selected_websites) {
      localStorage.selected_SOVWebsite = JSON.parse(
        localStorage.selected_websites
      )[0].key;
      this.selected_SOVWebsite = localStorage.selected_SOVWebsite;
    }
    localStorage.removeItem("selected_website_array");
    localStorage.removeItem("selected_channel_array");
    localStorage.removeItem("selected_websites");
    localStorage.removeItem("comp_check");
    if (localStorage.cpuFilter) this.cpuFilter = JSON.parse(localStorage.cpuFilter);
    if (localStorage.brandFilter) this.brandFilter = JSON.parse(localStorage.brandFilter);
    if (localStorage.checkedOemReviewsBrands)
      this.checkedOemReviewsBrands = JSON.parse(localStorage.checkedOemReviewsBrands);
    if (localStorage.checkedReviewsProcessors)
      this.checkedReviewsProcessors = JSON.parse(localStorage.checkedReviewsProcessors);
    if (localStorage.checkedReviewsProducts)
      this.checkedReviewsProducts = JSON.parse(localStorage.checkedReviewsProducts);
    if (localStorage.allReviewProductsCheck)
      this.allReviewProductsCheck = JSON.parse(localStorage.allReviewProductsCheck);

    if (localStorage.ratingExp) this.ratingExp = localStorage.ratingExp;
    if (localStorage.ratingInput1) this.ratingInput1 = localStorage.ratingInput1;
    if (localStorage.ratingInput2) this.ratingInput2 = localStorage.ratingInput2;
    if (localStorage.fourKSeries) this.fourKSeries = JSON.parse(localStorage.fourKSeries);
    if (localStorage.fiveKSeries) this.fiveKSeries = JSON.parse(localStorage.fiveKSeries);
    if (localStorage.sixKSeries) this.sixKSeries = JSON.parse(localStorage.sixKSeries);
    if (localStorage.sevenSeries) this.sevenSeries = JSON.parse(localStorage.sevenSeries);

    if (localStorage.reviewStartDate) {
      this.reviewStartDate = localStorage.reviewStartDate;
      this.reviewEndDate = localStorage.reviewEndDate;
    } else {
      this.reviewStartDate = moment().subtract(2, "month").format("YYYY-MM-DD");
      this.reviewEndDate = this.date.startDate;
    }
    this.sovStartDate = moment(this.date.startDate)
      .subtract(1, "week")
      .format("YYYY-MM-DD");
    this.sovEndDate = this.date.startDate;

    if (this.price_sites.includes(this.selected_SOVWebsite)) this.isPrice = true;
    else this.isPrice = false;

    if (this.oem_websites.includes(this.selected_SOVWebsite)) {
      this.showBrand = false;
      this.showBrandHP = false;
      this.isOEM = true;
      this.labelMapper = {
        processor_type: "AMD Processor",
      };
    } else if (this.selected_SOVWebsite == "https://www.currys.co.uk") {
      this.showBrand = false;
      this.isOEM = false;
    } else if (this.selected_SOVWebsite == "https://www.harveynorman.com.au") {
      this.isOEM = false;
      if (this.device == "desktop") this.showBrand = false;
      else this.showBrand = true;
    } else {
      this.isOEM = false;
      this.showBrand = true;
      this.showBrandHP = true;
      this.labelMapper = {
        brand: "AMD Brand",
        processor_type: "AMD Processor",
        // 'gpu_type': 'GPU'
      };
    }
    if (this.selected_SOVWebsite == "https://www.hpstore.cn#commercial") {
      this.priceBandData = {
        chart1: {
          start_date: moment().subtract(7, "days").format("YYYY-MM-DD"),
          end_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
          data: {},
        },
        chart2: {
          start_date: moment().subtract(7, "days").format("YYYY-MM-DD"),
          end_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
          data: {},
        },
      };
    } else {
      this.priceBandData = {
        chart1: {
          start_date: moment().subtract(7, "days").format("YYYY-MM-DD"),
          end_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
          data: {},
        },
        chart2: {
          start_date: moment().subtract(14, "days").format("YYYY-MM-DD"),
          end_date: moment().subtract(8, "days").format("YYYY-MM-DD"),
          data: {},
        },
      };
    }
    if (this.oem_websites.includes(this.selected_SOVWebsite)) {
      this.getWebsiteSOS();
      this.getComplianceTrend();
    } else {
      this.priceBandsProcessor();
    }
    this.sov();
    this.website_details();
    this.ryzenVsNonRyzen();
    this.getDailyData();
    this.getDailyDataOEM();
    this.getComData();
    this.getProducts();
    if (this.selected_SOVWebsite != "all") this.getPriceBands();

    if (this.selected_SOVWebsite != "all")
      localStorage.selected_SOVWebsite = this.selected_SOVWebsite;
    localStorage.selected_category = this.device;
  },
  methods: {
    processpPriceBandsProcessorGraph(data) {
      let self = this;
      let cat = Object.keys(data.data);
      let catSignChanged = [];
      let amdData = [];
      let intelData = [];
      let appleData = [];
      cat.sort(function (a, b) {
        let a1 = a.replace(">", "").replace("<", "");
        let b1 = b.replace(">", "").replace("<", "");
        return a1.localeCompare(b1, undefined, { numeric: true, sensitivity: "base" });
      });
      for (let [idx, dataset] of cat.entries()) {
        catSignChanged.push(
          dataset.replace(/\$/g, self.websitesPriceMap[self.selected_SOVWebsite])
        );
        amdData.push(data.data[dataset].amd_sov);
        intelData.push(data.data[dataset].intel_sov);
        appleData.push(data.data[dataset].apple_sov);
      }
      let obj = {};
      obj.title = "Processor SOV by Priceband";
      obj.chart = {
        chart: {
          type: "column",
          height: 320,
          marginTop: 60,
          marginBottom: 40,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: catSignChanged,
          title: {
            text: "Total " + self.deviceMapper[self.device] + ": " + data.all_count,
            style: {
              fontWeight: "bold",
              color: "#47A694",
            },
            verticalAlign: "top",
            align: "left",
            x: 0,
            y: -305,
          },
        },
        yAxis: {
          title: {
            text: "",
          },
          stackLabels: {
            enabled: true,
            formatter: function () {
              return this.total + "%";
            },
          },
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -7,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        tooltip: {
          valueSuffix: "%",
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
              useHTML: true,
              formatter: function () {
                return (
                  '<span style="z-index:-9999;color:white;font-size:10px;font-weight:normal;">' +
                  self.format(Number(this.point.y.toFixed())) +
                  "% </span>"
                );
              },
            },
          },
        },
        series: [
          {
            name: "AMD",
            data: amdData,
            color: "#47A694",
            borderWidth: 0,
          },
          {
            name: "Intel",
            data: intelData,
            color: "#54736D",
            borderWidth: 0,
          },
          {
            name: "Nvidia",
            data: appleData,
            color: "#265950",
            borderWidth: 0,
          },
        ],
      };
      self.priceBandsProcessorGraphs.push(obj);
    },
    processProductChecking: function (event) {
      this.allReviewProductsCheck = false;
      if (event.target.checked) {
        this.checkedReviewsProducts.push(event.target.value);
      } else {
        this.checkedReviewsProducts.splice(event.target.value, 1);
      }
    },
    processAllProductChecking: function (event) {
      if (event.target.checked) {
        this.checkedReviewsProducts = [];
      } else {
        this.checkedReviewsProducts = [];
      }
    },

    priceBandsProcessor() {
      let self = this;
      self.priceBandsProcessorGraphs = [];
      self.loader = true;
      let payload = {
        website: self.selected_SOVWebsite,
        start_date: moment(self.pbpStartDate).format("YYYY-MM-DD"),
        end_date: moment(self.pbpEndDate).format("YYYY-MM-DD"),
        item_category: self.device,
      };
      if (self.pbpPage == "1" || self.pbpPage == "all") payload["page"] = self.pbpPage;
      const url = "/api/websites/price_bands_processor";
      self.$http.post(url, payload).then(
        (response) => {
          if (Object.keys(response.data.data).length)
            self.processpPriceBandsProcessorGraph(response.data);
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    processComplianceTrendData(data) {
      let self = this;
      let obj = {
        id: "complianceTrend",
        xAxis: [],
        seriesData: [
          {
            name: self.websitesUrls3[self.selected_SOVWebsite],
            data: [],
            color: "#47A694",
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
      for (let [idx, dataset] of data.data.entries()) {
        obj.xAxis.push(moment(dataset.timestamp).format("MMM DD, YY"));
        obj.seriesData[0].data.push(dataset.final_complaince_score);
      }
      self.complianceTrend.push(obj);
    },
    getComplianceTrend() {
      let self = this;
      self.complianceTrend = [];
      self.loader = true;
      let payload = {
        website: self.selected_SOVWebsite,
        start_date: moment(self.comTrendStartDate).format("YYYY-MM-DD"),
        end_date: moment(self.comTrendEndDate).format("YYYY-MM-DD"),
        item_category: self.device,
      };
      const url = "/api/websites/compliance_timeline";
      self.$http.post(url, payload).then(
        (response) => {
          if (response.data.data.length) self.processComplianceTrendData(response.data);
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    exportTimelineRetail() {
      let self = this;
      let payload = {
        interval: this.sovInterval,
        data: [],
        website: this.selected_SOVWebsite,
      };
      let cat = this.daywiseChartPage1.xAxis.categories;
      for (let [idx, dataset] of [
        { page: "Page 1", ckey: "daywiseChartPage1" },
        { page: "Pages (1-3)", ckey: "daywiseChart" },
      ].entries()) {
        let obj = {};
        obj.title =
          "SOV trend for " + self.deviceMapper[self.device] + " category " + dataset.page;
        obj.timeline = [];
        for (let [idx2, dataset2] of cat.entries()) {
          let obj2 = {};
          obj2.date = dataset2;
          for (let [idx3, dataset3] of this[dataset.ckey].series.entries()) {
            if (dataset3.name == "AMD SOV") {
              obj2["amd_count"] = dataset3.data[idx2].count;
              obj2["total"] = dataset3.data[idx2].total;
            } else if (dataset3.name == "Ryzen SOV") {
              obj2["ryzen"] = dataset3.data[idx2].count;
              obj2["total"] = dataset3.data[idx2].total;
            } else if (dataset3.name == "Non-Ryzen SOV") {
              obj2["non_ryzen"] = dataset3.data[idx2].count;
              obj2["total"] = dataset3.data[idx2].total;
            }
          }
          obj.timeline.push(obj2);
        }
        payload.data.push(obj);
      }
      for (let [idx, dataset] of [
        { page: "Page 1", ckey: "page1ProcessorData" },
        { page: "Pages (1-3)", ckey: "allProcessorData" },
      ].entries()) {
        if (self[dataset.ckey].length) {
          let obj = {};
          obj.title =
            "Apple/Intel SOV trend for " +
            self.deviceMapper[self.device] +
            " category " +
            dataset.page;
          obj.timeline = [];
          for (let [idx2, dataset2] of self[dataset.ckey].entries()) {
            let obj2 = {};
            obj2["date"] = self.formatDate("sovInterval", dataset2.timestamp);
            obj2["apple_count"] = dataset2.apple_count;
            obj2["intel_count"] = dataset2.intel_count;
            obj2["total"] = dataset2.page_count;
            obj.timeline.push(obj2);
          }
          payload.data.push(obj);
        }
      }
      const url = "/api/sov/export_data_excel";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.data.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    exportTimeline() {
      let self = this;
      let payload = {
        interval: this.sovIntervalOEM,
        data: [],
        website: this.selected_SOVWebsite,
      };
      // console.log("check oem data", this.daywiseChartOEM);
      let cat = this.daywiseChartOEM[0].chart.xAxis.categories;
      // console.log("check all oem data", this.daywiseChartOEM[0].chart.xAxis.categories);
      for (let [idx, dataset] of this.daywiseChartOEM.entries()) {
        // console.log("break line idx", idx);
        let obj = {};
        obj.title = dataset.title.trim();
        obj.timeline = [];
        let cat2 = dataset.chart.xAxis.categories;
        // console.log("new category #######################", cat2);
        // console.log("check all the ", dataset.chart.series, "idx", idx);
        for (let [idx2, dataset2] of cat2.entries()) {
          // console.log("check name of site cat", dataset2, "idx2", idx2, "cat", cat);
          let obj2 = {};
          obj2.date = dataset2;
          for (let [idx3, dataset3] of dataset.chart.series.entries()) {
            // console.log("check count array", dataset3.data[idx2], "idx3", idx3);
            if (dataset3.name.includes("AMD")) {
              obj2["amd_count"] = dataset3.data[idx2].count;
              obj2["total"] = dataset3.data[idx2].total;
            } else {
              obj2["intel_count"] = dataset3.data[idx2].count;
              obj2["total"] = dataset3.data[idx2].total;
            }
          }
          obj.timeline.push(obj2);
        }
        payload.data.push(obj);
      }
      const url = "/api/sov/export_data_excel";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.data.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    goToSOVDetail() {
      window.location = "#/sovdetailed";
    },
    websiteChanged() {
      if (
        this.selected_SOVWebsite == "https://www.newegg.com" ||
        this.selected_SOVWebsite == "https://www.microcenter.com"
      ) {
        this.device = "gpu";
      } else this.device = "laptop";

      this.refresh();
    },
    getClassSOVSOS() {
      if (this.websiteSOSGraphs.length == 1) return "col-md-12 card ";
      if (this.websiteSOSGraphs.length == 2) return "col-md-6 mycols  card ";
      if (this.websiteSOSGraphs.length == 3) return "col-md-4 mycols card ";
      if (this.websiteSOSGraphs.length >= 4)
        return "col-md-6 ycols card customGraphHeading";
    },
    getClassSOVSOSButton() {
      if (this.websiteSOSGraphs.length == 1) return "navigationButton";
      if (this.websiteSOSGraphs.length == 2) return "navigationButton";
      if (this.websiteSOSGraphs.length == 3) return "navigationButtonSmall";
      if (this.websiteSOSGraphs.length >= 4) return "navigationButtonSmall";
    },
    renderPriceBandGraphs(d, i) {
      let self = this;
      let category = [];
      let series = [];
      self.priceBandData[i].data = {};
      let color_codes = [
        "#47A694",
        "#54736D",
        "#265950",
        "#79A69E",
        "#317367",
        "#54736D",
        "#52BFAB",
        "#84B5AC",
        "#5F827C",
        "#388273",
        "#59CFB7",
      ];
      let bandKeys = ["<$400", "$400-$600", "$600-$800", ">$800"];
      if (d.data.length) {
        for (let [idx, dataset] of bandKeys.entries())
          series.push({
            name: dataset.replace(/\$/g, self.websitesPriceMap[self.selected_SOVWebsite]),
            customKey: dataset,
            data: [],
            customCount: [],
            tooltip: { valueSuffix: "%" },
            color: color_codes[idx],
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          });
        for (let [idx, dataset] of series.entries())
          for (let [idx2, dataset2] of d.data.entries()) {
            category.push(
              "Page " +
                dataset2.page +
                "<br/>Total AMD " +
                self.deviceMapper[self.device] +
                ": " +
                dataset2.count
            );
            dataset.data.push({
              y: dataset2.price_bands[dataset.customKey].sov,
              count: dataset2.price_bands[dataset.customKey].count,
            });
          }

        self.priceBandData[i].data = {
          chart: {
            type: "line",
            height: 230,
            marginTop: 30,
          },
          title: {
            text: "",
          },
          subtitle: {
            verticalAlign: "bottom",
            text: "",
          },
          xAxis: {
            categories: category,
            title: {
              text: null,
            },
            crosshair: {
              width: 70,
            },
          },
          plotOptions: {
            line: {
              marker: {
                enabled: true,
              },

              dataLabels: {
                enabled: true,
                allowOverlap: true,
                style: { fontWeight: 0 },
                formatter: function () {
                  return this.point.y + "%";
                },
              },
            },
          },
          yAxis: {
            min: 0,
            title: {
              text: "",
            },
          },
          tooltip: {
            formatter: function () {
              var mytooltip = this.points[0].key.slice(0, 6) + "<br/>";
              for (var i = 0; i < this.points.length; i++) {
                mytooltip += this.points[i].series.name;
                mytooltip +=
                  ":<b> " +
                  self.format(this.points[i].y) +
                  "% (" +
                  this.points[i].point.count +
                  ")<br/>";
              }
              return mytooltip;
            },
            shared: true,
            borderWidth: 0,
            shadow: {
              color: "#d6d6d6",
              opacity: 0.1,
              width: 10,
            },
            borderRadius: 6,
            backgroundColor: "#ffffff",
          },

          legend: {
            enabled: true,
            labelFormatter: function () {
              return this.name;
            },
          },
          credits: {
            enabled: false,
          },
          series: series,
        };
      }
    },
    getPriceBands() {
      let self = this;
      self.loader = true;
      for (let [idx, dataset] of Object.entries(self.priceBandData)) {
        self.priceBandResponse[idx] = [];

        let payload = {
          website: this.selected_SOVWebsite,
          item_category: self.device,
          start_date: moment(dataset.start_date).format("YYYY-MM-DD"),
          end_date: moment(dataset.end_date).format("YYYY-MM-DD"),
        };
        const url = "/api/websites/price_bands";
        self.$http.post(url, payload).then(
          (response) => {
            self.priceBandResponse[idx] = response.body.data;
            self.renderPriceBandGraphs(response.body, idx);
            self.loader = false;
          },
          (err) => {
            self.loader = false;
            console.log("err");
          }
        );
      }
    },
    removeRatingFilter() {
      this.ratingInput1 = "";
      this.ratingInput2 = "";
      if (localStorage.ratingExp) delete localStorage.ratingExp;
      if (localStorage.ratingInput1) delete localStorage.ratingInput1;
      if (localStorage.ratingInput2) delete localStorage.ratingInput2;
      this.changeFilter();
    },
    applyRatingFilter() {
      let self = this;
      if (self.ratingInput1 > 5) {
        alert("Rating value should be between 0 and 5");
        return false;
      }
      if (self.ratingInput1 < 0) {
        alert("Rating value should be between 0 and 5");
        return false;
      }
      if (self.ratingExp == "between") {
        if (self.ratingInput2 > 5) {
          alert("Rating value should be between 0 and 5");
          return false;
        }
        if (self.ratingInput2 < 0) {
          alert("Rating value should be between 0 and 5");
          return false;
        }
      }
      self.changeFilter();
    },
    orderAxis(uo_xaxis) {
      let keylist = ["brand", "consumer", "commercial"];
      let arr = [];
      for (let [k, v] of keylist.entries()) {
        for (let [idx, dataset] of uo_xaxis.sort().entries()) {
          if (dataset.indexOf(v) != -1) {
            arr.push(dataset);
          }
        }
      }
      return arr;
    },
    drawWebSOSGraphs(d) {
      let self = this;
      let max = 0;
      let customColor = "#47A694";
      for (let [so_i, so_d] of ["sov_data", "sos_data"].entries()) {
        for (let [eachSo_i, eachSo_d] of d[so_d].entries()) {
          console.log("check data for graph", eachSo_d);
          let sovsosobj = {};
          sovsosobj.title =
            "AMD Vs Intel " +
            self.deviceMapper[self.device] +
            " " +
            eachSo_d.label.toUpperCase();
          let uo_xaxis = [];
          let o_xaxis = [];
          let data = [];
          let obj = {};
          let max = 0;
          let total = "";
          for (let [idx, dataset] of eachSo_d.data.entries()) {
            let name = dataset.processor.replace("amd", "AMD") + " " + dataset.segment;
            uo_xaxis.push(name);
            let val = Math.round(dataset.sov);
            obj[name] = val;
            if (dataset.sov > max) max = dataset.sov + 5;
            if (dataset.segment == "consumer") total = dataset.total_count;
            if (dataset.segment == "commercial") total = dataset.total_count;
          }
          o_xaxis = self.orderAxis(uo_xaxis);
          for (let [idx, dataset] of o_xaxis.entries()) {
            data.push(obj[dataset]);
          }
          sovsosobj.chart = {
            credits: {
              enabled: false,
            },
            chart: {
              type: "column",
              height: 320,
              inverted: true,
              marginTop: 60,
              marginBottom: 40,
            },
            title: {
              text: "",
            },
            subtitle: {
              text: "Total " + self.deviceMapper[self.device] + ": " + total,
              style: {
                fontWeight: "bold",
                color: "#47A694",
              },
              verticalAlign: "top",
              align: "left",
              x: -8,
              y: 25,
            },

            yAxis: {
              title: {
                text: "",
                style: {
                  fontWeight: "bold",
                },
              },

              max: max,
              tickInterval: 5,
            },
            plotOptions: {
              column: {
                dataLabels: {
                  enabled: true,
                  formatter: function () {
                    return this.point.y + "%";
                  },
                },
              },
            },
            xAxis: {
              categories: o_xaxis,
              crosshair: true,
            },
            legend: { enabled: false },
            tooltip: {
              formatter: function () {
                var mytooltip = this.points[0].key;
                for (var i = 0; i < this.points.length; i++) {
                  mytooltip += this.points[i].series.name;
                  mytooltip += ":<b> " + self.format(this.points[i].y) + "%";
                }
                return mytooltip;
              },
              shared: true,
              borderWidth: 0,
              shadow: {
                color: "#d6d6d6",
                opacity: 0.1,
                width: 10,
              },
              borderRadius: 6,
              backgroundColor: "#47A694",
              style: {
                color: "#fff",
                fontWeight: "bold",
              },
            },
            series: [
              {
                name: "",
                data: data,
                height: "10px",
                color: customColor,
              },
            ],
          };
          self.websiteSOSGraphs.push(sovsosobj);
        }
      }
    },
    getWebsiteSOS() {
      let self = this;
      self.loader = true;
      self.websiteSOSGraphs = [];
      let payload = {
        website: [this.selected_SOVWebsite],
        // "website": ['https://store.hp.com/us#commercial'],
        item_category: self.device,
        timestamp: self.date.startDate,
        // "timestamp": moment().format('YYYY-MM-DD')
      };
      const url = "/api/websites/website_sos";
      self.$http.post(url, payload).then(
        (response) => {
          self.drawWebSOSGraphs(response.body);
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    checkChannel() {
      if (
        this.selected_SOVWebsite == "https://www.amazon.com" ||
        this.selected_SOVWebsite == "https://www.amazon.fr" ||
        this.selected_SOVWebsite == "https://www.amazon.co.it" ||
        this.selected_SOVWebsite == "https://www.amazon.es" ||
        this.selected_SOVWebsite == "https://www.amazon.co.uk" ||
        this.selected_SOVWebsite == "https://www.amazon.de" ||
        this.selected_SOVWebsite == "https://www.harveynorman.com.au" ||
        this.selected_SOVWebsite == "https://www.costco.com" ||
        this.selected_SOVWebsite == "https://www.walmart.com" ||
        this.selected_SOVWebsite == "https://global.jd.com" ||
        this.selected_SOVWebsite == "https://www.bestbuy.com" ||
        this.selected_SOVWebsite == "https://www.currys.co.uk" ||
        this.selected_SOVWebsite == "https://www.mediamarkt.de"
      ) {
        return true;
      } else {
        return false;
      }
    },
    changeFilter() {
      this.pickProduct = false;
      this.selectedProduct = [];
      this.checkedReviewsProducts = [];
      this.allReviewProductsCheck = true;
      if (this.checkedReviewsProcessors) {
        this.cpuFilter = this.checkedReviewsProcessors.map((obj) => obj.label);
      }
      if (this.checkedOemReviewsBrands) {
        this.brandFilter = this.checkedOemReviewsBrands.map((obj) => obj.label);
      }
      localStorage.selected_product = JSON.stringify(this.selectedProduct);
      localStorage.checkedReviewsProducts = JSON.stringify(this.checkedReviewsProducts);
      localStorage.allReviewProductsCheck = JSON.stringify(this.allReviewProductsCheck);
      if (this.cpuFilter) localStorage.cpuFilter = JSON.stringify(this.cpuFilter);
      else delete localStorage.cpuFilter;
      if (this.brandFilter) localStorage.brandFilter = JSON.stringify(this.brandFilter);
      else delete localStorage.brandFilter;
      if (this.checkedReviewsProcessors)
        localStorage.checkedReviewsProcessors = JSON.stringify(
          this.checkedReviewsProcessors
        );
      else delete localStorage.checkedReviewsProcessors;
      if (this.checkedOemReviewsBrands)
        localStorage.checkedOemReviewsBrands = JSON.stringify(
          this.checkedOemReviewsBrands
        );
      else delete localStorage.checkedOemReviewsBrands;

      if (this.ratingExp) localStorage.ratingExp = this.ratingExp;
      else delete localStorage.ratingExp;
      if (this.ratingInput1) localStorage.ratingInput1 = this.ratingInput1;
      else delete localStorage.ratingInput1;
      if (this.ratingInput2) localStorage.ratingInput2 = this.ratingInput2;
      else delete localStorage.ratingInput2;
      if (this.fourKSeries) localStorage.fourKSeries = JSON.stringify(this.fourKSeries);
      else delete localStorage.fourKSeries;
      if (this.fiveKSeries) localStorage.fiveKSeries = JSON.stringify(this.fiveKSeries);
      else delete localStorage.fiveKSeries;
      if (this.sixKSeries) localStorage.sixKSeries = JSON.stringify(this.sixKSeries);
      else delete localStorage.sixKSeries;
      if (this.sevenSeries) localStorage.sevenSeries = JSON.stringify(this.sevenSeries);
      else delete localStorage.sevenSeries;
      this.filterActions();
    },
    filterActions() {
      this.productOptions = [];
      let brandCheck = true;
      let cpuCheck = true;
      let ratingCheck = true;
      let seriesCheck = true;

      let ratingExpMapper = {
        eq: function (a, b) {
          return a == b;
        },
        gt: function (a, b) {
          return b > a;
        },
        gte: function (a, b) {
          return b >= a;
        },
        lt: function (a, b) {
          return b < a;
        },
        lte: function (a, b) {
          return b <= a;
        },
        between: function (a1, a2, b) {
          return b >= a1 && b <= a2;
        },
      };

      let processor_model_list = [];

      if (this.fourKSeries) processor_model_list.push("4");
      if (this.fiveKSeries) processor_model_list.push("5");
      if (this.sixKSeries) processor_model_list.push("6");
      if (this.sevenSeries) processor_model_list.push("7");

      for (let [ii, rr] of this.productOptionsFull.entries()) {

        if (this.brandFilter) brandCheck = this.brandFilter.includes(rr.brand_name);
        if (this.cpuFilter) cpuCheck = this.cpuFilter.includes(rr.processor_type);
        if (this.ratingExp != "between" && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1, rr.rating);
        else if (this.ratingExp == "between" && this.ratingInput1 && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](
            this.ratingInput1,
            this.ratingInput2,
            rr.rating
          );

        seriesCheck = processor_model_list.includes(rr.processor_model[0]);

        if (processor_model_list.length == 0) seriesCheck = true;
        if (this.brandFilter.length == 0) brandCheck = true;
        if (this.cpuFilter.length == 0) cpuCheck = true;

        if (brandCheck && cpuCheck && ratingCheck && seriesCheck) {
          this.productOptions.push(rr);
        }
      }
      this.refreshReview();
    },
    checkSearchFilter(d) {
      let self = this;
      if (d.toLowerCase().indexOf(self.schProduct.toLowerCase()) != -1) {
        return true;
      } else {
        return false;
      }
    },
    selectProductNow() {
      let self = this;
      self.pickProduct = true;
      self.selectedProduct = this.checkedReviewsProducts;
      localStorage.selected_product = JSON.stringify(self.checkedReviewsProducts);
      localStorage.checkedReviewsProducts = JSON.stringify(this.checkedReviewsProducts);
      localStorage.allReviewProductsCheck = JSON.stringify(this.allReviewProductsCheck);
      self.refreshReview();
      self.isProductModal = false;
    },
    showProductModal() {
      let self = this;
      self.isProductModal = true;
    },

    goToCompliance() {
      let self = this;
      localStorage.selectedWebComplianceScore = self.selectedWebComplianceScore;
      window.location = "#/compliance-detail";
    },
    formatDate(key, d) {
      let self = this;
      let obj = {
        day: moment(d).format("MMM DD, YY"),
        month: moment(d).format("MMM YY"),
        week: "",
      };
      if (self[key] == "week") {
        let end_date = moment(d).add(6, "days");
        let today = moment(self.date.startDate);
        if (end_date >= today) end_date = today;

        let weekStart = moment(d).format("MMM DD, YY");
        let weekEnd = moment(end_date).format("MMM DD, YY");
        if(key === 'revInterval') {
          if (moment(d) < moment(this.reviewStartDate))
          weekStart = moment(this.reviewStartDate).format("MMM DD, YY");

          if (moment(end_date) > moment(this.reviewEndDate))
            weekEnd = moment(this.reviewEndDate).format("MMM DD, YY");
        } else {
          if (moment(d) < moment(this.sovStartDate))
            weekStart = moment(this.sovStartDate).format("MMM DD, YY");
  
          if (moment(end_date) > moment(this.sovEndDate))
            weekEnd = moment(this.sovEndDate).format("MMM DD, YY");
        }
        obj["week"] = weekStart + " - " + weekEnd;
      }
      return obj[this[key]];
    },
    drawReviewGraph(reviewData) {
      let self = this;
      self.totalReviewCount = reviewData.count;
      self.ratingAvg = 0;
      let revRat = [
        {
          label: "Review",
          key: "review_count",
          graph: "reviewGraph",
          active: "activeReviewGraph",
        },
        {
          label: "Rating",
          key: "rating",
          graph: "ratingGraph",
          active: "activeRatingGraph",
        },
        {
          label: "cumulative Review",
          key: "commulative_review_count",
          graph: "creviewGraph",
          active: "activeReviewGraph",
        },
        {
          label: "cumulative Rating",
          key: "commulative_rating",
          graph: "cratingGraph",
          active: "activeReviewGraph",
        },
        // { label:'Rating', key:'rating', graph: 'ratingGraph', active: 'activeRatingGraph' }
      ];
      if (reviewData.timeline.length)
        self.ratingAvg = reviewData.timeline[
          reviewData.timeline.length - 1
        ].commulative_rating.toFixed(1);
      let y_labels = [
        "Review Count",
        "Avg. Rating",
        "Cumulative Review Count",
        "Cumulative Rating",
      ];
      let tick_arr = [50, 1];
      let max_arr = [undefined, 5];
      for (let [ii, rr] of revRat.entries()) {
        let cat = [];
        let data = [];
        for (let [idx, dataset] of reviewData.timeline.entries()) {
          cat.push(self.formatDate("revInterval", dataset.date));
          data.push(dataset[rr.key]);
        }
        self[rr.graph] = {
          chart: {
            type: "line",
            height: 250,
            // marginBottom: 10,
            marginTop: 20,
          },
          title: {
            text: "",
          },
          subtitle: {
            text: "",
          },
          xAxis: {
            categories: cat,
            title: {
              text: null,
            },
            crosshair: {
              width: 70,
            },
          },
          plotOptions: {
            line: {
              // dataLabels: {
              //     enabled: true,
              //     style:{fontWeight:0},
              //     formatter:function(){
              //       let d = this.series.userOptions.detail[this.point.index]
              //       return this.point.y + '% (' + d + ')'
              //     },
              // }
            },
          },
          yAxis: {
            min: 0,
            tickInterval: tick_arr[ii],
            max: max_arr[ii],
            title: {
              text: y_labels[ii],
              margin: 25,
              style: {
                color: "#065559",
              },
            },
          },
          tooltip: {
            formatter: function () {
              var mytooltip = this.key + "<br/>";

              mytooltip += '<span style="color:' + this.series.color + '">\u25CF</span> ';
              mytooltip += this.series.name;
              mytooltip += " : <b> " + self.format(this.y);

              mytooltip += "</b><br/>";

              return mytooltip;
            },
            borderWidth: 0,
            shadow: {
              color: "#d6d6d6",
              opacity: 0.1,
              width: 10,
            },
            borderRadius: 6,
            backgroundColor: "#ffffff",
          },

          legend: {
            enabled: false,
          },
          credits: {
            enabled: false,
          },
          series: [
            {
              name: rr.label,
              data: data,
              color: "#47A694",
              marker: {
                states: {
                  hover: {
                    radiusPlus: 5,
                    lineWidthPlus: 3,
                  },
                },
              },
            },
          ],
        };
        if (rr.graph == "ratingGraph") self["ratingGraph"]["yAxis"]["min"] = 1;
        setTimeout(function () {
          self[rr.active] = true;
        }, 200);
      }
    },
    getReviews() {
      let self = this;
      self.loader = true;
      self.activeReviewGraph = false;
      let payload = {
        start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
        end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
        interval: self.revInterval,
        client: "AMD",
        item_category: self.device,
      };
      if (self.sponCheck) {
        payload["sponsored"] = self.sponCheck;
      }
      if (self.brandFilter) {
        console.log("check brand filter", self.brandFilter);
        payload["brand"] = self.brandFilter;
      }
      if (self.cpuFilter) {
        payload["processor"] = self.cpuFilter;
      }

      if (self.selected_SOVWebsite != "all") {
        payload["channel"] = self.websitesUrls[self.selected_SOVWebsite];
      }
      const allProductName = JSON.parse(JSON.stringify(self.productOptions));
      const processorSeries = [];
      if (self.selectedProduct.length) {
        payload["product_name"] = self.selectedProduct;
      }
      if (
        self.ratingInput1 ||
        self.fourKSeries ||
        self.fiveKSeries ||
        self.sixKSeries ||
        self.sevenSeries
      ) {
        if (self.fourKSeries) processorSeries.push(4);
        if (self.fiveKSeries) processorSeries.push(5);
        if (self.sixKSeries) processorSeries.push(6);
        if (self.sevenSeries) processorSeries.push(7);
        if (self.pickProduct) {
          if (self.selectedProduct.length) payload["product_name"] = self.selectedProduct;
          else {
            payload["product_name"] = allProductName.map((val) => val.key);
            // for (let [ii, rr] of this.productOptions.entries()) {
            //   payload["product_name"].push(rr.key);
            // }
          }
        } else {
          payload["product_name"] = allProductName.map((val) => val.key);
          // for (let [ii, rr] of this.productOptions.entries()) {
          //   payload["product_name"].push(rr.key);
          // }
        }
      }
      payload["processor_model"] = processorSeries;
      const url = "/api/websites/review_histogram";
      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.drawReviewGraph(response.body.data);
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    refreshReview() {
      let self = this;
      localStorage.reviewStartDate = this.reviewStartDate;
      localStorage.reviewEndDate = this.reviewEndDate;
      self.getReviews();
    },
    getProducts() {
      let self = this;
      self.loader = true;
      self.productOptions = [];
      self.selectedProduct = {};
      self.productOptionsFull = [];
      const url = "/api/websites/website_products";
      let payload = {};
      payload["website"] = [];
      payload["item_category"] = self.device;
      payload["start_date"] = moment(self.reviewStartDate).format("YYYY-MM-DD");
      payload["end_date"] = moment(self.reviewEndDate).format("YYYY-MM-DD");

      if (self.selected_SOVWebsite == "all") {
        for (let [idx, dataset] of Object.entries(self.websitesUrls)) {
          if (!self.oem_websites.includes(idx)) payload["website"].push(idx);
        }
      } else {
        payload["website"].push(self.selected_SOVWebsite);
      }
      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.errorInProduct = false;
          if (!response.body.data.length) {
            self.selectedProduct = [];
            self.drawReviewGraph({ count: 0, timeline: [] });
            return;
          }
          // self.productOptions = response.body.data.sort()
          self.productOptionsFull = response.body.data;
          self.filterKeys.brand = response.body.brand_list.sort();
          self.filterKeys.processor_type = response.body.processor_list.sort();

          if (localStorage.selected_product)
            self.selectedProduct = JSON.parse(localStorage.selected_product);
          else {
            self.selectedProduct = [];
            localStorage.selected_product = JSON.stringify(self.selectedProduct);
          }
          self.filterActions();
        },
        (err) => {
          self.loader = false;
          self.errorInProduct = true;
          console.log("err");
        }
      );
    },
    drawComChart(d) {
      let self = this;

      let categories = [];
      let data1 = [];
      let arr = [];
      let highlight_color = "";
      let sumFinalScore = 0;
      self.selectedWebComplianceScore = "";
      for (let [idx, dataset] of Object.entries(d)) {
        if (self.selected_SOVWebsite == idx) {
          self.selectedWebComplianceScore = dataset.final_complaince_score;
        } else if (self.selected_SOVWebsite == "all") {
          sumFinalScore += dataset.final_complaince_score;
        }
        arr.push({
          url: idx,
          data: dataset.final_complaince_score,
          total: dataset.total_count,
        });
      }
      if (self.selected_SOVWebsite == "all") {
        self.selectedWebComplianceScore = Number(
          sumFinalScore / Object.keys(d).length
        ).toFixed();
      }

      let sortedArr = arr.sort((a, b) => a.data - b.data);
      let newsortedArr = [];
      for (let [idx, dataset] of sortedArr.entries()) {
        if (self.oem_websites.includes(self.selected_SOVWebsite)) {
          if (self.oem_websites.includes(dataset.url)) newsortedArr.push(dataset);
        } else {
          if (!self.oem_websites.includes(dataset.url)) newsortedArr.push(dataset);
        }
      }
      for (let [idx, dataset] of newsortedArr.entries()) {
        if (newsortedArr.length == 1) categories.push(self.websitesUrls3[dataset.url]);
        else {
          if (idx == 0)
            categories.push(
              self.websitesUrls3[dataset.url] + "<br/> <b>(Least Compliant)</b>"
            );
          else if (idx == newsortedArr.length - 1)
            categories.push(
              self.websitesUrls3[dataset.url] + "<br/> <b>(Most Compliant)</b>"
            );
          else categories.push(self.websitesUrls3[dataset.url]);
        }
        if (self.selected_SOVWebsite == dataset.url) highlight_color = "#01695C";
        else highlight_color = "#46877D";
        data1.push({ y: dataset.data, color: highlight_color });
      }
      let plotLine = [];
      let midx = parseInt(data1.length / 2);
      if (self.isOEM) {
        plotLine.push({
          color: "#FFAB00",
          width: 1,
          value: 85,
          dashStyle: "shortdash",
          zIndex: 4,
          label: { text: 85 },
        }); //static lin at 85
      } else {
        plotLine.push({
          color: "#FFAB00",
          width: 1,
          value: data1[midx].y,
          dashStyle: "shortdash",
          zIndex: 4,
        }); //dynamic line at data1[midx].y
      }
      self.comChart = {
        chart: {
          type: "column",
          height: 230,
          marginTop: 30,
          // marginBottom: 60,
        },
        title: {
          text: " ",
        },
        subtitle: {
          text: "",
        },
        xAxis: {
          categories: categories,
          title: {
            text: "Websites",
            style: {
              color: "#01695C",
              fontWeight: 600,
              fontSize: "15px",
            },
          },
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
              style: { fontWeight: 0 },
              formatter: function () {
                return this.point.y;
              },
            },
          },
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Compliance Score",
            margin: 25,
            style: {
              color: "#065559",
            },
          },
          plotLines: plotLine,
        },
        tooltip: {
          shared: true,
          enabled: false,
        },

        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "",
            data: data1,
            // color: '#8a87e8',
            pointWidth: 60,
            dataSorting: {
              enabled: true,
            },
          },
        ],
      };
      setTimeout(function () {
        self.activeComChart = true;
      }, 0);
    },
    getComData() {
      let self = this;
      self.loader = true;
      self.activeComChart = false;
      let payload = {};
      payload["timestamp"] = self.date.startDate;
      payload["item_category"] = self.device;
      let url = "/api/websites/compliance_score";
      if (self.isOEM) {
        url = "/api/websites/oem_compliance_score";
        if (self.commercialSites.includes(self.selected_SOVWebsite))
          url = "/api/websites/commercial_compliance_score";
      }
      if (this.device == "gpu" || this.device == "cpu") {
        url = "/api/website/cpu_gpu_compliance_score";
      }
      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.drawComChart(response.body.data);
          // console.log("chcek data com",response.body.data)
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    goToDetailPage() {
      // window.location = "#/sov-detailed";
      this.$router.push("/sov-detailed");
    },
    goToSenti() {
      // window.location = "#/reviewslist";
      this.$router.push("/reviewslist");
    },
    drawDailyAMDCount(d) {
      let self = this;
      let categories = [];
      let data = [];
      let data2 = [];
      let data3 = [];
      let laptop_count = 0;
      for (let [idx, dataset] of d.entries()) {
        categories.push(self.formatDate("sovInterval", dataset.timestamp));
        data.push(dataset.amd_count);
        data2.push(dataset.all_count);
        data3.push(dataset.sov);
      }
      self.daywiseAMDCount = {
        chart: {
          type: "line",
          height: 230,
          marginTop: 60,
          marginBottom: 40,
        },
        title: {
          text: "",
        },
        subtitle: {
          verticalAlign: "bottom",
          text: "",
        },
        xAxis: {
          categories: categories,
          title: {
            text: null,
          },
        },
        yAxis: [
          {
            min: 0,
            title: {
              text: "Count",
              margin: 25,
              style: {
                color: "#065559",
              },
            },
          },
          {
            min: 0,
            title: {
              text: "AMD SOS",
              margin: 25,
              style: {
                color: "#065559",
              },
            },
            opposite: false,
          },
        ],
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' + this.points[i].series.color + '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip += " : <b> " + self.format(this.points[i].y);
              if (this.points[i].series.name.indexOf("SOS") != -1) mytooltip += "%";
              mytooltip += "</b><br/>";
            }
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -7,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "AMD " + self.deviceMapper[self.device],
            data: data,
            zIndex: 9,
            type: "bar",
            color: "#47A694",
            yAxis: 0,
          },
          {
            name: "All " + self.deviceMapper[self.device],
            data: data2,
            type: "bar",
            color: "#265950",
            yAxis: 0,
          },
          {
            name: "AMD SOS",
            data: data3,
            yAxis: 1,
            type: "line",
            pointWidth: 1,
            color: "#FCB116",
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
    },
    drawDailyAMDCountGaming(d) {
      let self = this;
      let categories = [];
      let data = [];
      let data2 = [];
      let data3 = [];
      let laptop_count = 0;
      for (let [idx, dataset] of d.entries()) {
        categories.push(self.formatDate("sovInterval", dataset.timestamp));
        data.push(dataset.amd_count);
        data2.push(dataset.all_count);
        data3.push(dataset.sov);
      }
      self.daywiseAMDCountGaming = {
        chart: {
          type: "line",
          height: 230,
          marginTop: 60,
          marginBottom: 40,
        },
        title: {
          text: "",
        },
        subtitle: {
          verticalAlign: "bottom",
          text: "",
        },
        xAxis: {
          categories: categories,
          title: {
            text: null,
          },
        },

        yAxis: [
          {
            min: 0,
            title: {
              text: "Count",
              margin: 25,
              style: {
                color: "#065559",
              },
            },
          },
          {
            min: 0,
            title: {
              text: "AMD SOS",
              margin: 25,
              style: {
                color: "#065559",
              },
            },
            opposite: false,
          },
        ],
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' + this.points[i].series.color + '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip += " : <b> " + self.format(this.points[i].y);
              if (this.points[i].series.name.indexOf("SOS") != -1) mytooltip += "%";
              mytooltip += "</b><br/>";
            }
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -7,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "AMD " + self.deviceMapper[self.device],
            data: data,
            zIndex: 9,
            type: "bar",
            color: "#47A694",
            yAxis: 0,
          },
          {
            name: "All " + self.deviceMapper[self.device],
            data: data2,
            type: "bar",
            color: "#265950",
            yAxis: 0,
          },
          {
            name: "AMD SOS",
            data: data3,
            yAxis: 1,
            type: "line",
            pointWidth: 1,
            color: "#FCB116",
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
    },
    drawDailyAMDCountAverage(d) {
      let self = this;
      let categories = [];
      let data = [];
      let data2 = [];
      let data3 = [];
      let laptop_count = 0;
      for (let [idx, dataset] of d.entries()) {
        categories.push(self.formatDate("sovInterval", dataset.timestamp));
        data.push(dataset.amd_count);
        data2.push(dataset.all_count);
        data3.push(dataset.sov);
      }
      self.daywiseAMDCountAverage = {
        chart: {
          type: "line",
          height: 230,
          marginTop: 60,
          marginBottom: 40,
        },
        title: {
          text: "",
        },
        subtitle: {
          verticalAlign: "bottom",
          text: "",
        },
        xAxis: {
          categories: categories,
          title: {
            text: null,
          },
        },

        yAxis: [
          {
            min: 0,
            title: {
              text: "Count",
              margin: 25,
              style: {
                color: "#065559",
              },
            },
          },
          {
            min: 0,
            title: {
              text: "AMD SOS",
              margin: 25,
              style: {
                color: "#065559",
              },
            },
            opposite: false,
          },
        ],
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' + this.points[i].series.color + '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip += " : <b> " + self.format(this.points[i].y);
              if (this.points[i].series.name.indexOf("SOS") != -1) mytooltip += "%";
              mytooltip += "</b><br/>";
            }
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -7,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "AMD " + self.deviceMapper[self.device],
            data: data,
            zIndex: 9,
            type: "bar",
            color: "#47A694",
            yAxis: 0,
          },
          {
            name: "All " + self.deviceMapper[self.device],
            data: data2,
            type: "bar",
            color: "#265950",
            yAxis: 0,
          },
          {
            name: "AMD SOS",
            data: data3,
            yAxis: 1,
            type: "line",
            pointWidth: 1,
            color: "#FCB116",
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
    },
    drawDailyPagePosition(d) {
      let self = this;
      let categories = [];
      let dataPage1 = [];
      let dataPage2 = [];
      let dataPage3 = [];
      let laptop_count = 0;
      for (let [idx, dataset] of d.entries()) {
        categories.push(self.formatDate("sovInterval", dataset.timestamp));
        dataPage1.push(dataset.data[1]);
        dataPage2.push(dataset.data[2]);
        dataPage3.push(dataset.data[3]);
      }
      let obj = {};
      self.daywisePositionChart = {
        chart: {
          type: "column",
          height: 320,
          marginTop: 60,
          marginBottom: 40,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: categories,
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "",
          },
        },
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          column: {
            stacking: "percent",
            dataLabels: {
              enabled: true,
              useHTML: true,
              zIndex: 0,
              formatter: function () {
                return (
                  '<span style="color:white;font-size:10px;font-weight:normal;">' +
                  self.format(Number(this.point.percentage.toFixed())) +
                  "% </span>"
                );
              },
            },
          },
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -7,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        series: [
          {
            name: "Page 1",
            data: dataPage1,
            color: "#47A694",
            borderWidth: 0,
          },
          {
            name: "Page 2",
            data: dataPage2,
            color: "#54736D",
            borderWidth: 0,
          },
          {
            name: "Page 3",
            data: dataPage3,
            color: "#265950",
            borderWidth: 0,
          },
        ],
      };
    },
    drawDailyChartAveragePage13() {
      let self = this;
      let categories = [];
      let data3 = [];
      let data4 = [];
      let amdSov = [];
      let detail1 = [];
      let detail2 = [];
      let detail3 = [];
      let laptop_count = 0;
      for (let [idx, dataset] of this.dailyDataAveragePage13.entries()) {
        categories.push(self.formatDate("sovInterval", dataset.timestamp));
        laptop_count = dataset.page_count;
        let ryzensov = Number(dataset.ryzen_sov);
        let nonryzensov = Number(dataset.non_ryzen_sov);
        data3.push(ryzensov);
        data4.push(nonryzensov);
        amdSov.push(Number(dataset.amd_sov));
        detail1.push(dataset.ryzen + "/" + dataset.page_count);
        detail2.push(dataset.non_ryzen + "/" + dataset.page_count);
        detail3.push(dataset.ryzen + dataset.non_ryzen + "/" + dataset.page_count);
      }
      let obj = {};
      self.daywiseChartAverage = {
        chart: {
          type: "line",
          height: 230,
          marginTop: 60,
          marginBottom: 40,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "Total " + self.deviceMapper[self.device] + ": " + laptop_count,
          style: {
            fontWeight: "bold",
            color: "#47A694",
          },
          verticalAlign: "top",
          align: "left",
          x: -8,
          y: 25,
        },
        xAxis: {
          categories: categories,
          title: {
            text: null,
          },
          crosshair: {
            width: 70,
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              allowOverlap: true,
              style: { fontWeight: 0 },

              formatter: function () {
                let category = this.point.category;
                let plotY = this.point.plotY;
                if (obj.hasOwnProperty(category)) obj[category].push(plotY);
                else {
                  obj[category] = [];
                  obj[category].push(plotY);
                }
                let plotYPos = obj[category].indexOf(plotY);
                let prvPlotY = obj[category][plotYPos - 1];
                if (plotYPos > 0) {
                  if (plotY - prvPlotY < 9 && plotY - prvPlotY > -9) {
                    this.point.plotY = this.point.plotY + 9;
                    obj[category][plotYPos] = this.point.plotY;
                  }
                }
                let d = this.series.userOptions.detail[this.point.index];
                return this.point.y + "%";
              },
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
        },
        tooltip: {
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },

        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -10,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "AMD SOV",
            data: amdSov,
            color: "#47A694",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail3,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Ryzen SOV",
            data: data3,
            color: "#FCB116",

            tooltip: {
              valueSuffix: "%",
            },
            detail: detail1,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Non-Ryzen SOV",
            data: data4,
            color: "#1ACF85",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail2,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
      // if(self.selected_SOVWebsite=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    drawDailyChartGamingPage13() {
      let self = this;
      let categories = [];
      let data3 = [];
      let data4 = [];
      let amdSov = [];
      let detail1 = [];
      let detail2 = [];
      let detail3 = [];
      let laptop_count = 0;
      for (let [idx, dataset] of this.dailyDataGamingPage13.entries()) {
        categories.push(self.formatDate("sovInterval", dataset.timestamp));
        laptop_count = dataset.page_count;
        let ryzensov = Number(dataset.ryzen_sov);
        let nonryzensov = Number(dataset.non_ryzen_sov);
        data3.push(ryzensov);
        data4.push(nonryzensov);
        amdSov.push(Number(dataset.amd_sov));
        detail1.push(dataset.ryzen + "/" + dataset.page_count);
        detail2.push(dataset.non_ryzen + "/" + dataset.page_count);
        detail3.push(dataset.ryzen + dataset.non_ryzen + "/" + dataset.page_count);
      }
      let obj = {};
      self.daywiseChartGaming = {
        chart: {
          type: "line",
          height: 230,
          marginTop: 60,
          marginBottom: 40,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "Total " + self.deviceMapper[self.device] + ": " + laptop_count,
          style: {
            fontWeight: "bold",
            color: "#47A694",
          },
          verticalAlign: "top",
          align: "left",
          x: -8,
          y: 25,
        },
        xAxis: {
          categories: categories,
          title: {
            text: null,
          },
          crosshair: {
            width: 70,
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              allowOverlap: true,
              style: { fontWeight: 0 },

              formatter: function () {
                let category = this.point.category;
                let plotY = this.point.plotY;
                if (obj.hasOwnProperty(category)) obj[category].push(plotY);
                else {
                  obj[category] = [];
                  obj[category].push(plotY);
                }
                let plotYPos = obj[category].indexOf(plotY);
                let prvPlotY = obj[category][plotYPos - 1];
                if (plotYPos > 0) {
                  if (plotY - prvPlotY < 9 && plotY - prvPlotY > -9) {
                    this.point.plotY = this.point.plotY + 9;
                    obj[category][plotYPos] = this.point.plotY;
                  }
                }
                let d = this.series.userOptions.detail[this.point.index];
                return this.point.y + "%";
              },
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
        },
        tooltip: {
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },

        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -35,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "AMD SOV",
            data: amdSov,
            color: "#47A694",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail3,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Ryzen SOV",
            data: data3,
            color: "#FCB116",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail1,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Non-Ryzen SOV",
            data: data4,
            color: "#1ACF85",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail2,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
      // if(self.selected_SOVWebsite=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    drawDailyChart() {
      let self = this;
      let categories = [];
      let data3 = [];
      let data4 = [];
      let amdSov = [];
      let detail1 = [];
      let detail2 = [];
      let detail3 = [];
      let laptop_count = 0;
      for (let [idx, dataset] of this.dailyData.entries()) {
        categories.push(self.formatDate("sovInterval", dataset.timestamp));
        laptop_count = dataset.page_count;
        let ryzensov = Number(dataset.ryzen_sov);
        let nonryzensov = Number(dataset.non_ryzen_sov);

        data3.push({ y: ryzensov, count: dataset.ryzen, total: dataset.page_count });
        data4.push({
          y: nonryzensov,
          count: dataset.non_ryzen,
          total: dataset.page_count,
        });
        amdSov.push({
          y: Number(dataset.amd_sov),
          count: dataset.amd_count,
          total: dataset.page_count,
        });

        detail1.push(dataset.ryzen + "/" + dataset.page_count);
        detail2.push(dataset.non_ryzen + "/" + dataset.page_count);
        detail3.push(dataset.ryzen + dataset.non_ryzen + "/" + dataset.page_count);
      }
      let obj = {};
      self.daywiseChart = {
        chart: {
          type: "line",
          height: 230,
          marginTop: 60,
          marginBottom: 40,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "Total " + self.deviceMapper[self.device] + ": " + laptop_count,
          style: {
            fontWeight: "bold",
            color: "#47A694",
          },
          verticalAlign: "top",
          align: "left",
          x: -8,
          y: 25,
        },
        xAxis: {
          categories: categories,
          crosshair: {
            width: 70,
          },
          title: {
            text: null,
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              allowOverlap: true,
              style: { fontWeight: 0 },

              formatter: function () {
                let category = this.point.category;
                let plotY = this.point.plotY;
                if (obj.hasOwnProperty(category)) obj[category].push(plotY);
                else {
                  obj[category] = [];
                  obj[category].push(plotY);
                }
                let plotYPos = obj[category].indexOf(plotY);
                let prvPlotY = obj[category][plotYPos - 1];
                if (plotYPos > 0) {
                  if (plotY - prvPlotY < 9 && plotY - prvPlotY > -9) {
                    this.point.plotY = this.point.plotY + 9;
                    obj[category][plotYPos] = this.point.plotY;
                  }
                }
                let d = this.series.userOptions.detail[this.point.index];
                return this.point.y + "%";
              },
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
        },
        tooltip: {
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },

        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -35,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "AMD SOV",
            data: amdSov,
            color: "#47A694",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail3,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Ryzen SOV",
            data: data3,
            color: "#FCB116",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail1,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Non-Ryzen SOV",
            data: data4,
            color: "#1ACF85",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail2,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
      // if(self.selected_SOVWebsite=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    processDailyChartCpuGpu(chartType) {
      let categories = [];
      let totalData = [];
      let detail = [];
      let totalCount = 0;
      let allData = [];
      if (chartType == "daily_data") allData = this.dailyData;
      if (chartType == "page_data") allData = this.dailyDataPage1;
      allData.forEach((dataset) => {
        categories.push(moment(dataset.timestamp).format("MMM DD, YY"));
        totalCount = dataset.total_count;
        let itemSov = Number(dataset.item_sov);

        totalData.push({ y: itemSov, count: dataset.item_count, total: totalCount });

        detail.push(dataset.item_count + "/" + dataset.page_count);
      });
      let obj = {
        id: "total_data",
        xAxis: categories,
        detail: detail,
        marginTop: 60,
        subtitle: {
          text: "Total " + this.deviceMapper[this.device] + ": " + totalCount,
          style: {
            fontWeight: "bold",
            color: "#47A694",
          },
          verticalAlign: "top",
          align: "left",
          x: -8,
          y: 25,
        },
        seriesData: [
          {
            name: "Total Data",
            data: totalData,
            tooltip: {
              valueSuffix: "%",
            },
            color: "#47A694",
            dataLabels: {
              enabled: true,
              format: "{y}%",
            },
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
      // for (let [idx, dataset] of this.dailyData.entries()) {
      //   obj.xAxis.push(moment(dataset.timestamp).format("MMM DD, YY"));
      //   obj.seriesData[0].data.push(dataset.total_count);
      // }
      if (chartType == "daily_data") this.cpuGpuDayWiseChart = obj;
      if (chartType == "page_data") this.cpuGpuDayWiseChartPage1 = obj;
      console.log("chart data", this.cpuGpuDayWiseChartPage1);
    },
    drawDailyChartPage1() {
      let self = this;
      let categories = [];
      let data3 = [];
      let data4 = [];
      let amdSov = [];
      let detail1 = [];
      let detail2 = [];
      let detail3 = [];
      let laptop_count = 0;
      for (let [idx, dataset] of this.dailyDataPage1.entries()) {
        categories.push(self.formatDate("sovInterval", dataset.timestamp));
        laptop_count = dataset.page_count;
        let ryzensov = Number(dataset.ryzen_sov);
        let nonryzensov = Number(dataset.non_ryzen_sov);
        data3.push({ y: ryzensov, count: dataset.ryzen, total: dataset.page_count });
        data4.push({
          y: nonryzensov,
          count: dataset.non_ryzen,
          total: dataset.page_count,
        });
        amdSov.push({
          y: Number(dataset.amd_sov),
          count: dataset.amd_count,
          total: dataset.page_count,
        });
        detail1.push(dataset.ryzen + "/" + dataset.page_count);
        detail2.push(dataset.non_ryzen + "/" + dataset.page_count);
        detail3.push(dataset.ryzen + dataset.non_ryzen + "/" + dataset.page_count);
      }
      let obj = {};
      self.daywiseChartPage1 = {
        chart: {
          type: "line",
          height: 230,
          marginTop: 60,
          marginBottom: 40,
        },
        title: {
          text: "",
        },
        subtitle: {
          verticalAlign: "top",
          align: "left",
          x: -8,
          y: 25,
          text: "Total " + self.deviceMapper[self.device] + ": " + laptop_count,
          style: {
            fontWeight: "bold",
            color: "#47A694",
          },
        },
        xAxis: {
          categories: categories,
          crosshair: {
            width: 70,
          },
          title: {
            text: null,
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              allowOverlap: true,
              style: { fontWeight: 0 },

              formatter: function () {
                let category = this.point.category;
                let plotY = this.point.plotY;
                if (obj.hasOwnProperty(category)) obj[category].push(plotY);
                else {
                  obj[category] = [];
                  obj[category].push(plotY);
                }
                let plotYPos = obj[category].indexOf(plotY);
                let prvPlotY = obj[category][plotYPos - 1];
                if (plotYPos > 0) {
                  if (plotY - prvPlotY < 9 && plotY - prvPlotY > -9) {
                    this.point.plotY = this.point.plotY + 9;
                    obj[category][plotYPos] = this.point.plotY;
                  }
                }
                let d = this.series.userOptions.detail[this.point.index];
                return this.point.y + "%";
              },
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
        },
        tooltip: {
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },

        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -35,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "AMD SOV",
            data: amdSov,
            color: "#47A694",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail3,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Ryzen SOV",
            data: data3,
            color: "#FCB116",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail1,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Non-Ryzen SOV",
            data: data4,
            color: "#1ACF85",
            tooltip: {
              valueSuffix: "%",
            },
            detail: detail2,
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
      // if(self.selected_SOVWebsite=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    drawDailyChartOEM(d) {
      let self = this;
      let sovsosmapper = {
        sov_data: "SOV",
        sos_data: "SOS",
      };
      for (let [so_i, so_d] of ["sov_data", "sos_data"].entries()) {
        for (let [eachSo_i, eachSo_d] of d[so_d].entries()) {
          let obj = {};
          let categories = [];
          for (let [idx, dataset] of eachSo_d.trend.entries()) {
            categories.push(self.formatDate("sovIntervalOEM", dataset.timestamp));
            for (let [idx2, dataset2] of dataset.data.entries()) {
              let name =
                dataset2.processor.replace("amd", "AMD") + " " + dataset2.segment;
              if (obj.hasOwnProperty(name)) {
                obj[name].push({
                  y: Math.round(dataset2.sov),
                  count: dataset2.count,
                  total: dataset2.total_count,
                });
              } else {
                obj[name] = [];
                obj[name].push({
                  y: Math.round(dataset2.sov),
                  count: dataset2.count,
                  total: dataset2.total_count,
                });
              }
            }
          }
          let keylist = ["brand", "consumer", "commercial"];
          for (let [k, v] of keylist.entries()) {
            let seriesData = [];
            // if (v == "brand") console.log(obj);
            for (let [idx, dataset] of Object.entries(obj)) {
              if (idx.indexOf(v) != -1) {
                // console.log("chdk ids", idx);
                seriesData.push({
                  name: idx,
                  data: dataset,
                  tooltip: { valueSuffix: "%" },
                  color: idx.includes("AMD") ? "#47A694" : "#FCB116",
                  marker: {
                    states: {
                      hover: {
                        radiusPlus: 5,
                        lineWidthPlus: 3,
                      },
                    },
                  },
                });
              }
            }
            if (seriesData.length) {
              let sovsosobj = {};
              sovsosobj.title =
                eachSo_d.label.toUpperCase() +
                " " +
                v.toUpperCase() +
                " " +
                sovsosmapper[so_d];
              sovsosobj.chart = {
                chart: {
                  type: "line",
                  height: 230,
                  marginTop: 60,
                  marginBottom: 40,
                },
                title: {
                  text: "",
                },
                subtitle: {
                  verticalAlign: "bottom",
                  text: "",
                },
                xAxis: {
                  categories: categories,
                  title: {
                    text: null,
                  },
                  crosshair: {
                    width: 70,
                  },
                },
                plotOptions: {
                  line: {
                    dataLabels: {
                      enabled: true,
                      allowOverlap: true,
                      style: { fontWeight: 0 },
                      formatter: function () {
                        return this.point.y + "%";
                      },
                    },
                  },
                },
                yAxis: {
                  min: 0,
                  title: {
                    text: "",
                    margin: 25,
                    style: {
                      color: "#065559",
                    },
                  },
                },
                tooltip: {
                  shared: true,
                  borderWidth: 0,
                  shadow: {
                    color: "#d6d6d6",
                    opacity: 0.1,
                    width: 10,
                  },
                  borderRadius: 6,
                  backgroundColor: "#ffffff",
                },
                legend: {
                  enabled: true,
                  alignColumns: true,
                  align: "right",
                  y: -7,
                  x: 0,
                  squareSymbol: true,
                  verticalAlign: "top",
                  itemDistance: 35,
                  margin: 0,
                  padding: 0,
                  symbolHeight: 14,
                  symbolWidth: 14,
                  symbolRadius: 4,
                },
                credits: {
                  enabled: false,
                },
                series: seriesData,
              };
              self.daywiseChartOEM.push(sovsosobj);
            }
          }
        }
      }
    },
    getDailyData() {
      let self = this;
      self.loader4 = true;
      self.daywiseAMDCount = {};
      self.allProcessorData = [];
      self.page1ProcessorData = [];
      const url = "/api/websites/daily_sov";
      const cpuGpUrl = "/api/websites/gpu_daily_sov";
      let payload = {};
      payload["website"] = [];
      payload["item_category"] = self.device;
      payload["timestamp"] = self.date.startDate;
      payload["interval"] = self.sovInterval;
      payload["start_date"] = moment(self.sovStartDate).format("YYYY-MM-DD");
      payload["end_date"] = moment(self.sovEndDate).format("YYYY-MM-DD");
      if (self.selected_SOVWebsite == "all") {
        for (let [idx, dataset] of Object.entries(self.websitesUrls)) {
          if (!self.oem_websites.includes(idx)) payload["website"].push(idx);
        }
      } else {
        payload["website"].push(self.selected_SOVWebsite);
      }
      self.$http.post(url, payload).then(
        (response) => {
          self.loader4 = false;
          if (self.selected_SOVWebsite == "https://global.jd.com") {
            self.dailyDataGamingPage13 = response.body.gaming_data;
            self.dailyDataAveragePage13 = response.body.average_data;
            self.drawDailyChartGamingPage13();
            self.drawDailyChartAveragePage13();
            self.drawDailyAMDCountGaming(response.body.gaming_all_data);
            self.drawDailyAMDCountAverage(response.body.average_all_data);
          }
          self.dailyData = response.body.data;
          self.allProcessorData = response.body.all_processor_data;
          self.page1ProcessorData = response.body.page_1_processor_data;
          self.dailyDataPage1 = response.body.page_1_data;
          self.drawDailyChart();
          self.drawDailyChartPage1();
          self.drawDailyAMDCount(response.body.all_data);
          self.drawDailyPagePosition(response.body.page_data);
        },
        (err) => {
          self.loader4 = false;
          console.log("err");
        }
      );
      payload["website"] = payload["website"][0];
      if (this.device == "gpu")
        self.$http.post(cpuGpUrl, payload).then(
          (response) => {
            self.dailyData = response.body.data.data;
            self.dailyDataPage1 = response.body.data.page_1_data;
            self.processDailyChartCpuGpu("daily_data");
            self.processDailyChartCpuGpu("page_data");
          },
          (err) => {
            console.log("err");
          }
        );
    },
    getDailyDataOEM() {
      let self = this;
      self.loader4 = true;
      const url = "/api/websites/website_sos_trend";
      self.daywiseChartOEM = [];
      let payload = {};
      payload["website"] = [];
      payload["item_category"] = self.device;
      payload["interval"] = self.sovIntervalOEM;
      payload["start_date"] = moment(self.sovStartDate).format("YYYY-MM-DD");
      payload["end_date"] = moment(self.sovEndDate).format("YYYY-MM-DD");
      if (self.selected_SOVWebsite == "all") {
        for (let [idx, dataset] of Object.entries(self.websitesUrls)) {
          if (!self.oem_websites.includes(idx)) payload["website"].push(idx);
        }
      } else {
        payload["website"].push(self.selected_SOVWebsite);
        // payload["website"].push('https://store.hp.com/us#commercial')
      }
      self.$http.post(url, payload).then(
        (response) => {
          self.loader4 = false;
          self.drawDailyChartOEM(response.body);
        },
        (err) => {
          self.loader4 = false;
          console.log("err");
        }
      );
    },

    processCategorySearchGraph() {
      let self = this;
      let cat = self.pageDistributionData.category;
      let srch = self.pageDistributionData.search;
      let catTotal = cat[1] + cat[2] + cat[3];
      let srchTotal = srch[1] + srch[2] + srch[3];

      self.categorySearchGraph = {
        chart: {
          type: "column",
          height: 320,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          opposite: true,
          categories: [
            self.deviceMapper[self.device] + " category page",
            self.deviceMapper[self.device] + " search page",
          ],
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "",
          },
        },
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          column: {
            stacking: "percent",
            dataLabels: {
              enabled: true,
              useHTML: true,
              zIndex: 0,
              formatter: function () {
                return (
                  '<span style="color:white;font-size:10px;font-weight:normal;">' +
                  self.format(Number(this.point.percentage.toFixed())) +
                  "% </span>"
                );
              },
            },
          },
        },
        series: [
          {
            name: "Page 1",
            data: [cat[1], srch[1]],
            color: "#00800080",
            borderWidth: 0,
          },
          {
            name: "Page 2",
            data: [cat[2], srch[2]],
            color: "#ffa5008a",
            borderWidth: 0,
          },
          {
            name: "Page 3",
            data: [cat[3], srch[3]],
            color: "#ff00008a",
            borderWidth: 0,
          },
        ],
      };
      if (!this.showBrand) {
        self.categorySearchGraph.xAxis.categories = [
          self.deviceMapper[self.device] + " category page",
        ];
        self.categorySearchGraph.series = [
          {
            name: "Page 1",
            data: [cat[1]],
            color: "#00800080",
            borderWidth: 0,
          },
          {
            name: "Page 2",
            data: [cat[2]],
            color: "#ffa5008a",
            borderWidth: 0,
          },
          {
            name: "Page 3",
            data: [cat[3]],
            color: "#ff00008a",
            borderWidth: 0,
          },
        ];
      }
    },
    processSOVSOSGraph() {
      let self = this;
      let sov = {
        ryzen:
          (self.pageDistributionData.sov.ryzen / self.pageDistributionData.sov.total) *
          100,
        nonRyzen:
          (self.pageDistributionData.sov.non_ryzen /
            self.pageDistributionData.sov.total) *
          100,
      };
      let sos = {
        ryzen:
          (self.pageDistributionData.sos.ryzen / self.pageDistributionData.sos.total) *
          100,
        nonRyzen:
          (self.pageDistributionData.sos.non_ryzen /
            self.pageDistributionData.sos.total) *
          100,
      };
      sov.ryzen = Number(sov.ryzen.toFixed());
      sov.nonRyzen = Number(sov.nonRyzen.toFixed());
      sos.ryzen = Number(sos.ryzen.toFixed());
      sos.nonRyzen = Number(sos.nonRyzen.toFixed());
      let maxScale = sos.ryzen + sos.nonRyzen + 5;
      if (sov.ryzen + sov.nonRyzen > sos.ryzen + sos.nonRyzen) {
        maxScale = sov.ryzen + sov.nonRyzen + 5;
      }
      self.sovSOSGraph = {
        chart: {
          type: "column",
          height: 320,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          opposite: true,
          categories: [
            "All " +
              self.deviceMapper[self.device] +
              " Category Pages <br/> Total " +
              self.deviceMapper[self.device] +
              " = " +
              self.pageDistributionData.sov.total,
            "All " +
              self.deviceMapper[self.device] +
              " Search Pages <br/> Total " +
              self.deviceMapper[self.device] +
              " = " +
              self.pageDistributionData.sos.total,
          ],
        },
        yAxis: {
          min: 0,
          max: maxScale,
          title: {
            text: "",
          },
          stackLabels: {
            enabled: true,
            formatter: function () {
              let suf = "";
              let total = "";
              if (this.x == 0) {
                suf =
                  self.pageDistributionData.sov.ryzen +
                  self.pageDistributionData.sov.non_ryzen;
                total = self.pageDistributionData.sov.total;
              } else {
                suf =
                  self.pageDistributionData.sos.ryzen +
                  self.pageDistributionData.sos.non_ryzen;
                total = self.pageDistributionData.sos.total;
              }
              return "AMD:" + this.total + "%";
            },
          },
        },
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
              useHTML: true,
              formatter: function () {
                let mapper = {};
                let d = this.series.userOptions.myData[this.point.index];

                mapper["Ryzen SOV"] = d.ryzen + "/" + d.total;
                mapper["Non-Ryzen SOV"] = d.non_ryzen + "/" + d.total;

                return (
                  '<span style="color:white;font-size:12px;font-weight:normal;">' +
                  self.format(this.point.y) +
                  "%"
                );
              },
            },
          },
        },
        series: [
          {
            name: "Ryzen SOV",
            data: [sov.ryzen, sos.ryzen],
            color: "#ffa500a8",
            borderWidth: 0,

            myData: [self.pageDistributionData.sov, self.pageDistributionData.sos],
          },
          {
            name: "Non-Ryzen SOV",
            data: [sov.nonRyzen, sos.nonRyzen],
            color: "grey",
            borderWidth: 0,

            myData: [self.pageDistributionData.sov, self.pageDistributionData.sos],
          },
        ],
      };
      if (
        self.selected_SOVWebsite == "https://store.hp.com/us" ||
        self.selected_SOVWebsite == "https://store.asus.com/us"
      ) {
        self.sovSOSGraph.xAxis.categories = [
          "All " +
            self.deviceMapper[self.device] +
            " Category / Search Pages <br/> Total " +
            self.deviceMapper[self.device] +
            " = " +
            self.pageDistributionData.sov.total,
        ];
        self.sovSOSGraph.series = [
          {
            name: "Ryzen SOV",
            data: [sov.ryzen],
            color: "#ffa500a8",
            borderWidth: 0,
            myData: [self.pageDistributionData.sov],
          },
          {
            name: "Non-Ryzen SOV",
            data: [sov.nonRyzen],
            color: "grey",
            borderWidth: 0,
            myData: [self.pageDistributionData.sov],
          },
        ];
      }
    },
    ryzenVsNonRyzen() {
      let self = this;
      self.loader3 = true;
      self.activecategorySearchGraph = false;
      const url = "api/websites/page_distribution";
      let payload = {};
      payload["website"] = [];
      payload["item_category"] = self.device;
      payload["timestamp"] = self.date.startDate;
      if (self.selected_SOVWebsite == "all") {
        for (let [idx, dataset] of Object.entries(self.websitesUrls)) {
          if (!self.oem_websites.includes(idx)) payload["website"].push(idx);
        }
      } else {
        payload["website"].push(self.selected_SOVWebsite);
      }
      self.$http.post(url, payload).then(
        (response) => {
          self.loader3 = false;
          self.pageDistributionData = response.body.data;
          self.processSOVSOSGraph();
          self.processCategorySearchGraph();
          self.activecategorySearchGraph = true;
        },
        (err) => {
          self.loader3 = false;
          console.log(err);
        }
      );
    },
    format(v) {
      return this.$options.filters.format(v);
    },
    refresh() {
      let self = this;
      self.priceBandsProcessorGraphs = [];
      self.cpuFilter = "";
      self.brandFilter = "";
      self.ratingExp = "eq";
      self.ratingInput1 = "";
      self.ratingInput2 = "";
      if (localStorage.cpuFilter) delete localStorage.cpuFilter;
      if (localStorage.brandFilter) delete localStorage.brandFilter;
      if (localStorage.ratingExp) delete localStorage.ratingExp;
      if (localStorage.ratingInput1) delete localStorage.ratingInput1;
      if (localStorage.ratingInput2) delete localStorage.ratingInput2;
      this.brandFilter = "";
      this.cpuFilter = "";
      $("#myTable").DataTable().destroy();
      if (localStorage.selected_SOVWebsite != this.selected_SOVWebsite)
        delete localStorage["selected_product"];
      if (localStorage.selected_category != this.device)
        delete localStorage["selected_product"];
      if (this.selected_SOVWebsite != "all")
        localStorage.selected_SOVWebsite = this.selected_SOVWebsite;
      localStorage.selected_category = this.device;
      this.showBrand = true;
      this.showBrandHP = true;
      this.isOEM = false;
      this.labelMapper = {
        brand: "Brand",
        processor_type: "AMD Processor",
        // 'gpu_type': 'GPU'
      };
      if (this.price_sites.includes(this.selected_SOVWebsite)) this.isPrice = true;
      else this.isPrice = false;
      if (this.oem_websites.includes(this.selected_SOVWebsite)) {
        this.showBrand = false;
        this.showBrandHP = false;
        this.isOEM = true;
        this.labelMapper = {
          processor_type: "AMD Processor",
        };
      } else if (this.selected_SOVWebsite == "https://www.currys.co.uk") {
        this.showBrand = false;
        this.isOEM = false;
      } else if (this.selected_SOVWebsite == "https://www.harveynorman.com.au") {
        this.isOEM = false;
        if (this.device == "desktop") this.showBrand = false;
        else this.showBrand = true;
      }
      if (this.selected_SOVWebsite == "https://www.hpstore.cn#commercial") {
        this.priceBandData = {
          chart1: {
            start_date: moment().subtract(7, "days").format("YYYY-MM-DD"),
            end_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
            data: {},
          },
          chart2: {
            start_date: moment().subtract(7, "days").format("YYYY-MM-DD"),
            end_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
            data: {},
          },
        };
      } else {
        this.priceBandData = {
          chart1: {
            start_date: moment().subtract(7, "days").format("YYYY-MM-DD"),
            end_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
            data: {},
          },
          chart2: {
            start_date: moment().subtract(14, "days").format("YYYY-MM-DD"),
            end_date: moment().subtract(8, "days").format("YYYY-MM-DD"),
            data: {},
          },
        };
      }

      this.sov();
      this.website_details();
      this.ryzenVsNonRyzen();
      this.getDailyData();
      this.getDailyDataOEM();
      this.getComData();
      this.getProducts();
      if (self.selected_SOVWebsite != "all") this.getPriceBands();
      if (this.oem_websites.includes(this.selected_SOVWebsite)) {
        this.getComplianceTrend();
        this.getWebsiteSOS();
      } else {
        this.priceBandsProcessor();
      }
    },
    sov() {
      let self = this;
      self.activeChart = false;
      self.loader = true;
      const url = "/api/websites/sov";
      let payload = {};
      payload["website"] = [];
      payload["item_category"] = self.device;
      payload["timestamp"] = self.date.startDate;
      if (self.selected_SOVWebsite == "all") {
        for (let [idx, dataset] of Object.entries(self.websitesUrls)) {
          if (!self.oem_websites.includes(idx)) payload["website"].push(idx);
        }
      } else {
        payload["website"].push(self.selected_SOVWebsite);
      }
      this.$http.post(url, payload).then(
        (response) => {
          this.rows = response.body.data.sov;
          this.sos_rows = response.body.data.sos;
          self.loader = false;
          self.$nextTick(function () {
            let xaxis = [];
            let data1 = [];
            let data2 = [];
            let data3 = [];
            let data4 = [];
            let max1 = 0;
            let max2 = 0;
            let limit = 9;
            let textCat =
              "Page 1 Count: <b>" +
              self.rows[0].page_1_count +
              "</b><br/>Pages 1-3 Count: <b>" +
              self.rows[0].page_1_3_count +
              "</b><br/>AMD " +
              self.deviceMapper[self.device] +
              " Count: <b>" +
              (self.rows[0].page_all_system_count + self.rows[1].page_all_system_count) +
              "</b>";
            let textSch =
              "Page 1 Count: <b>" +
              self.sos_rows[0].page_1_count +
              "</b><br/>Pages 1-3 Count: <b>" +
              self.sos_rows[0].page_1_3_count +
              "</b><br/>AMD " +
              self.deviceMapper[self.device] +
              " Count: <b>" +
              (self.sos_rows[0].page_all_system_count +
                self.sos_rows[1].page_all_system_count) +
              "</b>";
            if (
              self.rows[0].page_all_system_count == 0 ||
              self.selected_SOVWebsite == "all"
            ) {
              textCat =
                "Page 1 Count: <b>" +
                self.rows[0].page_1_count +
                "</b><br/>Pages 1-3 Count: <b>" +
                self.rows[0].page_1_3_count +
                "</b>";
              textSch =
                "Page 1 Count: <b>" +
                self.sos_rows[0].page_1_count +
                "</b><br/>Pages 1-3 Count: <b>" +
                self.sos_rows[0].page_1_3_count +
                "</b>";
              limit = 9;
            }
            for (let [idx, dataset] of self.columns.slice(3, limit).entries()) {
              if (
                dataset.field != "page_1_count" &&
                dataset.field != "page_all_count" &&
                dataset.field != "page_1_system_count" &&
                dataset.field != "page_all_system_count" &&
                dataset.field != "page_1_3_count" &&
                dataset.field != "page_1_3_system_count"
              ) {
                var d1 = Number(self.rows[0][dataset.field].toFixed());
                var d2 = Number(self.rows[1][dataset.field].toFixed());
                var d3 = Number(self.sos_rows[0][dataset.field].toFixed());
                var d4 = Number(self.sos_rows[1][dataset.field].toFixed());
                if (d1 >= max1) max1 = d1;
                if (d2 >= max1) max1 = d2;
                if (d3 >= max2) max2 = d3;
                if (d4 >= max2) max2 = d4;
                xaxis.push(dataset.label);
                data1.push(d1);
                data2.push(d2);
                data3.push(d3);
                data4.push(d4);
              }
            }

            self.charts = {
              credits: {
                enabled: false,
              },
              chart: {
                type: "column",
                height: 320,
                inverted: true,
              },
              title: {
                text: "",
              },
              subtitle: {
                align: "left",
                text: textCat,
              },
              yAxis: {
                title: {
                  text: "",
                },
                max: max1 + 5,
              },
              plotOptions: {
                column: {
                  dataLabels: {
                    enabled: true,
                    color: "black",
                    inside: false,
                    formatter: function () {
                      let mapper = {};
                      let d = this.series.userOptions.allData;
                      mapper["Page 1 SOV"] = d.page_1_system_count + "/" + d.page_1_count;
                      mapper["Pages 1-3 SOV"] =
                        d.page_1_3_system_count + "/" + d.page_1_3_count;
                      mapper["All Pages SOV"] =
                        d.page_all_system_count + "/" + d.page_all_count;
                      if (mapper[this.key]) return this.point.y + "%";
                      else return this.point.y;
                    },
                  },
                },
              },
              xAxis: {
                categories: xaxis,
                crosshair: true,
              },
              tooltip: {
                formatter: function () {
                  var mytooltip = this.points[0].key + "<br/>";
                  for (var i = 0; i < this.points.length; i++) {
                    mytooltip +=
                      '<span style="color:' +
                      this.points[i].series.color +
                      '">\u25CF</span> ';
                    mytooltip += this.points[i].series.name;
                    mytooltip += " : <b> " + self.format(this.points[i].y);
                    if (this.points[0].key.indexOf("SOV") != -1) mytooltip += "%";
                    mytooltip += "</b><br/>";
                  }
                  return mytooltip;
                },
                shared: true,
              },
              series: [
                {
                  name: self.rows[0]["sub_brand"],
                  data: data1,
                  color: "#3368fa8c",
                  allData: self.rows[0],
                },
                {
                  name: self.rows[1]["sub_brand"],
                  data: data2,
                  color: "#833c808c",
                  allData: self.rows[1],
                },
              ],
            };

            self.charts_sos = {
              credits: {
                enabled: false,
              },
              chart: {
                type: "column",
                height: 320,
                inverted: true,
              },
              title: {
                text: "",
              },
              subtitle: {
                align: "left",
                text: textSch,
              },

              yAxis: {
                title: {
                  text: "",
                },
                max: max2 + 5,
              },
              plotOptions: {
                column: {
                  dataLabels: {
                    enabled: true,
                    color: "black",
                    formatter: function () {
                      let mapper = {};
                      let d = this.series.userOptions.allData;
                      mapper["Page 1 SOV"] = d.page_1_system_count + "/" + d.page_1_count;
                      mapper["Pages 1-3 SOV"] =
                        d.page_1_3_system_count + "/" + d.page_1_3_count;
                      mapper["All Pages SOV"] =
                        d.page_all_system_count + "/" + d.page_all_count;
                      if (mapper[this.key]) return this.point.y + "%";
                      else return this.point.y;
                    },
                  },
                },
              },
              xAxis: {
                categories: xaxis,
                crosshair: true,
              },
              tooltip: {
                formatter: function () {
                  var mytooltip = this.points[0].key + "<br/>";
                  for (var i = 0; i < this.points.length; i++) {
                    mytooltip +=
                      '<span style="color:' +
                      this.points[i].series.color +
                      '">\u25CF</span> ';
                    mytooltip += this.points[i].series.name;
                    mytooltip += " : <b> " + self.format(this.points[i].y);
                    if (this.points[0].key.indexOf("SOV") != -1) mytooltip += "%";
                    mytooltip += "</b><br/>";
                  }
                  return mytooltip;
                },
                shared: true,
              },
              series: [
                {
                  name: self.sos_rows[0]["sub_brand"],
                  data: data3,
                  color: "#3368fa8c",
                  allData: self.sos_rows[0],
                },
                {
                  name: self.sos_rows[1]["sub_brand"],
                  data: data4,
                  color: "#833c808c",
                  allData: self.sos_rows[1],
                },
              ],
            };
            $("#myTable").DataTable();
            self.activeChart = true;
          });
        },
        (err) => {
          self.loader = false;
          console.log(err);
        }
      );
    },
    format(v) {
      return this.$options.filters.format(v);
    },
    countIt(listingType, dataset) {
      let self = this;
      for (let [i, d] of Object.entries(this.labelMapper)) {
        if (dataset[i] == "" || dataset[i] == " ") dataset[i] = "N/A";
        if (dataset[i].indexOf("amd") != -1)
          dataset[i] = dataset[i].replace("amd", "AMD");
        if (dataset[i].indexOf("hp") != -1) dataset[i] = dataset[i].replace("hp", "HP");
        if (isNaN(self[listingType][i][dataset[i]])) self[listingType][i][dataset[i]] = 1;
        else self[listingType][i][dataset[i]]++;
      }
    },
    getColorShades(baseColor) {
      if (this.index[baseColor] > this.colorShades[baseColor].length - 1) {
        this.index[baseColor] = 0;
      }
      let c = this.colorShades[baseColor][this.index[baseColor]];
      this.index[baseColor]++;
      return c;
    },
    generatePieCharts(listingType, chartKey) {
      let self = this;
      for (let [idx, dataset] of Object.entries(self[listingType])) {
        let seriesData = [];
        let finalSeriesData = [];
        let color_codes = [
          "#47A694",
          "#54736D",
          "#265950",
          "#79A69E",
          "#317367",
          "#54736D",
          "#52BFAB",
          "#84B5AC",
          "#5F827C",
          "#388273",
          "#59CFB7",
        ];
        let color_index = 0;
        let color_index1 = 0;
        let color_index3 = 0;
        for (let [idx2, dataset2] of Object.entries(dataset)) {
          let obj = {};
          let color = {};
          let whichCpu = "";
          let whichGpu = "";
          if (idx == "brand") {
            color[idx2] = color_codes[color_index3];
            color_index3 = color_index3 + 1;
          } else if (idx == "processor_type") {
            if (idx2.indexOf("amd") != -1 || idx2.indexOf("AMD") != -1) {
              color[idx2] = color_codes[color_index];
              whichCpu = "amd";
            } else if (
              idx2.indexOf("intel") != -1 ||
              idx2.indexOf("pentium") != -1 ||
              idx2.indexOf("core") != -1
            ) {
              whichCpu = "intel";
              color[idx2] = color_codes[color_index];
            } else {
              whichCpu = "N/A";
            }
            color_index = color_index + 1;
          } else if (idx == "gpu_type") {
            if (idx2.indexOf("amd") != -1 || idx2.indexOf("radeon") != -1) {
              whichGpu = "amd";
              color[idx2] = color_codes[color_index1];
            } else if (
              idx2.indexOf("intel") != -1 ||
              idx2.indexOf("uhd") != -1 ||
              idx2.indexOf("iris") != -1 ||
              idx2.indexOf("integrated") != -1
            ) {
              whichGpu = "intel";
              color[idx2] = color_codes[color_index1];
            } else if (idx2.indexOf("nvidia") != -1 || idx2.indexOf("geforce") != -1) {
              whichGpu = "nvidia";
              color[idx2] = color_codes[color_index1];
            } else {
              whichGpu = "N/A";
            }
            color_index1 = color_index1 + 1;
          }
          if (idx2 == "N/A") color[idx2] = "#b9c6de";

          obj["name"] = idx2;
          obj["y"] = dataset2;
          obj["cpu"] = whichCpu;
          obj["gpu"] = whichGpu;
          if (color[idx2]) obj["color"] = color[idx2];
          seriesData.push(obj);
        }
        if (idx == "brand") {
          finalSeriesData = seriesData;
        } else if (idx == "processor_type") {
          for (let [idx, dataset] of seriesData.entries()) {
            if (dataset.cpu == "N/A") finalSeriesData.push(dataset);
          }
          for (let [idx, dataset] of seriesData.entries()) {
            if (dataset.cpu == "amd") finalSeriesData.push(dataset);
          }
          for (let [idx, dataset] of seriesData.entries()) {
            if (dataset.cpu == "intel") finalSeriesData.push(dataset);
          }
        } else if (idx == "gpu_type") {
          for (let [idx, dataset] of seriesData.entries()) {
            if (dataset.gpu == "N/A") finalSeriesData.push(dataset);
          }
          for (let [idx, dataset] of seriesData.entries()) {
            if (dataset.gpu == "amd") finalSeriesData.push(dataset);
          }
          for (let [idx, dataset] of seriesData.entries()) {
            if (dataset.gpu == "intel") finalSeriesData.push(dataset);
          }
          for (let [idx, dataset] of seriesData.entries()) {
            if (dataset.gpu == "nvidia") finalSeriesData.push(dataset);
          }
        }
        self[chartKey][idx] = {
          chart: {
            margin: [80, 0, 35, 0],
            padding: [0, 0, 0, 0],
          },
          title: {
            text:
              self.deviceMapper[self.device] +
              " Category Page (" +
              self.selectedPage +
              ") Distribution by " +
              self.labelMapper[idx],
            verticalAlign: "bottom",
            style: { fontSize: 13 },
          },
          credits: {
            enabled: false,
          },
          accessibility: {
            point: {
              valueSuffix: "%",
            },
          },
          tooltip: {
            formatter() {
              var mytooltip = "";
              mytooltip +=
                '<span style="font-size:22px;color:' +
                this.point.color +
                '">\u25CF</span> ';
              mytooltip += this.point.name;
              mytooltip +=
                " : <b> " +
                self.format(this.point.y) +
                " (" +
                self.format(this.point.percentage.toFixed()) +
                "%)</b> <br/>";
              mytooltip += "Total: <b>" + self.format(this.point.total) + "</b>";
              return mytooltip;
            },
          },
          plotOptions: {
            series: {
              borderWidth: 0,
            },
            pie: {
              dataLabels: {
                enabled: true,
                useHTML: true,
                formatter: function () {
                  self.pieTotal = this.point.total;

                  return (
                    '<span style="color:black;font-size:12px;font-weight:normal;">' +
                    self.format(this.point.percentage.toFixed()) +
                    "%</span>"
                  );
                },
                distance: -13,
                style: {
                  fontSize: 11,
                },
              },
              showInLegend: true,
              size: "100%",
            },
          },
          legend: {
            align: "center",
            layout: "horizontal",
            verticalAlign: "top",
            itemStyle: {
              fontSize: 11,
              fontWeight: 1,
            },
            maxHeight: 65,
          },
          series: [
            {
              type: "pie",
              data: finalSeriesData,
            },
          ],
        };
        setTimeout(function () {
          self.activePie = true;
        }, 50);
      }
    },
    readyPieCharts() {
      let self = this;
      self.clearPieDataset();
      for (let [idx, dataset] of this.rows_details.entries()) {
        if (self.selectedPage == 1 && dataset.page != 1) continue;
        if (dataset.processor == "amd") {
          if (self.amdCPUFilter == "all") {
            self.countIt("countAMD", dataset);
          } else if (self.amdCPUFilter == "ryzen") {
            if (dataset.processor_type.indexOf("ryzen") != -1)
              self.countIt("countAMD", dataset);
            else continue;
          } else {
            if (dataset.processor_type.indexOf("ryzen") == -1)
              self.countIt("countAMD", dataset);
            else continue;
          }
        }
      }
      self.generatePieCharts("countAMD", "pieChartAMD");
    },
    createPie() {
      let self = this;
      let color_codes = [
        "#47A694",
        "#54736D",
        "#265950",
        "#79A69E",
        "#317367",
        "#54736D",
        "#52BFAB",
        "#84B5AC",
        "#5F827C",
        "#388273",
        "#59CFB7",
      ];
      let color_index_total = 0;
      let color_index = 0;
      let color = {};
      let color_total = {};
      let total = 0;
      let seriesData = [];
      let totalData = self.total_processor_data;
      let alltotal = 0;
      for (let [idx, dataset] of totalData.entries()) {
        color_total[dataset.name] = color_codes[color_index_total];
        color_index_total = color_index_total + 1;
        dataset.color = color_total[dataset.name];
        alltotal = alltotal + dataset.y;
      }
      self["pieChartAMDTotal"] = {
        chart: {
          marginTop: 60,
          marginBottom: 40,
        },
        title: {
          text:
            self.deviceMapper[self.device] +
            " Category Page (" +
            self.selectedPage +
            ") Distribution by Processor",
          verticalAlign: "bottom",
          style: { ffontSize: 15, fontWeight: "600", color: "#01695C" },
        },
        credits: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          formatter() {
            var mytooltip = "";
            mytooltip +=
              '<span style="font-size:22px;color:' +
              this.point.color +
              '">\u25CF</span> ';
            mytooltip += this.point.name;
            mytooltip +=
              " : <b> " +
              self.format(this.point.y) +
              " (" +
              self.format(this.point.percentage.toFixed()) +
              "%)</b> <br/>";
            mytooltip += "Total: <b>" + self.format(this.point.total) + "</b>";
            return mytooltip;
          },
          valueSuffix: "%",
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            borderRadius: 7,
          },
          pie: {
            dataLabels: {
              enabled: true,
              useHTML: true,
              formatter: function () {
                self.pieTotalAll = this.point.total;

                return (
                  '<span style="color:white;font-size:12px;font-weight:normal;">' +
                  self.format(this.point.percentage.toFixed()) +
                  "%</span>"
                );
              },
              distance: -30,
              style: {
                fontSize: 11,
              },
            },
            showInLegend: true,
            size: "100%",
          },
        },

        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -7,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        series: [
          {
            type: "pie",
            innerSize: "50%",
            data: totalData,
          },
        ],
      };
      for (const property in self.labelMapper) {
        if (property == "brand") seriesData = self.pie_brand;
        else if (property == "processor_type") seriesData = self.pie_cpu;
        for (let [idx, dataset] of seriesData.entries()) {
          color[dataset.name] = color_codes[color_index];
          color_index = color_index + 1;
          dataset.color = color[dataset.name];
          total = total + dataset.y;
        }
        for (let [idx, dataset] of seriesData.entries()) {
          dataset.total = total;
        }
        self.pieSeriesData = seriesData;
        self["pieChartAMD"][property] = {
          chart: {
            marginTop: 60,
            marginBottom: 40,
          },
          title: {
            text:
              self.deviceMapper[self.device] +
              " Category Page (" +
              self.selectedPage +
              ") Distribution by " +
              self.labelMapper[property],
            verticalAlign: "bottom",
            style: { fontSize: 15, fontWeight: "600", color: "#01695C" },
          },
          credits: {
            enabled: false,
          },
          accessibility: {
            point: {
              valueSuffix: "%",
            },
          },
          tooltip: {
            formatter() {
              var mytooltip = "";
              mytooltip +=
                '<span style="font-size:22px;color:' +
                this.point.color +
                '">\u25CF</span> ';
              mytooltip += this.point.name;
              mytooltip +=
                " : <b> " +
                self.format(this.point.y) +
                " (" +
                self.format(this.point.percentage.toFixed()) +
                "%)</b> <br/>";
              mytooltip += "Total: <b>" + self.format(this.point.total) + "</b>";
              return mytooltip;
            },
            shared: true,
            borderWidth: 0,
            shadow: {
              color: "#d6d6d6",
              opacity: 0.1,
              width: 10,
            },
            borderRadius: 6,
            backgroundColor: "#ffffff",
          },
          plotOptions: {
            series: {
              borderWidth: 0,
            },
            pie: {
              dataLabels: {
                enabled: true,
                useHTML: true,
                formatter: function () {
                  self.pieTotal = this.point.total;

                  return (
                    '<span style="color:white;font-size:12px;font-weight:normal;">' +
                    self.format(this.point.percentage.toFixed()) +
                    "%</span>"
                  );
                },
                distance: -30,
                style: {
                  fontSize: 11,
                },
              },
              showInLegend: true,
              size: "100%",
            },
          },
          legend: {
            enabled: true,
            alignColumns: true,
            align: "right",
            y: -7,
            x: 0,
            squareSymbol: true,
            verticalAlign: "top",
            itemDistance: 35,
            margin: 0,
            padding: 0,
            symbolHeight: 14,
            symbolWidth: 14,
            symbolRadius: 4,
          },
          series: [
            {
              type: "pie",
              innerSize: "50%",
              data: seriesData,
            },
          ],
        };
        setTimeout(function () {
          self.activePie = true;
        }, 50);
      }
    },
    readyPie() {
      let self = this;
      let filter_data = [];
      self.pie_brand = [];
      self.pie_cpu = [];
      self.total_processor_data = [];
      this.brand_list = self.pie_data[self.amdCPUFilter][self.selectedPage]["brand_list"];
      this.cpu_list = self.pie_data[self.amdCPUFilter][self.selectedPage]["cpu_list"];
      this.total_processor_list = self.total_pie_data[self.selectedPage]["data"];
      for (let [idx, dataset] of this.brand_list.entries()) {
        let di = {};
        di["name"] = dataset["key"];
        di["y"] = dataset["doc_count"];
        if (di["name"] == "") di["name"] = "N/A";
        if (di["name"].indexOf("amd") != -1)
          di["name"] = di["name"].replace("amd", "AMD");
        if (di["name"].indexOf("hp") != -1) di["name"] = di["name"].replace("hp", "HP");
        self.pie_brand.push(di);
      }
      for (let [idx, dataset] of this.cpu_list.entries()) {
        let di = {};
        di["name"] = dataset["key"];
        di["y"] = dataset["doc_count"];
        if (di["name"] == "") di["name"] = "N/A";
        if (di["name"].indexOf("amd") != -1)
          di["name"] = di["name"].replace("amd", "AMD");
        if (di["name"].indexOf("hp") != -1) di["name"] = di["name"].replace("hp", "HP");
        self.pie_cpu.push(di);
      }
      for (let [idx, dataset] of this.total_processor_list.entries()) {
        let di = {};
        di["name"] = dataset["key"];
        di["y"] = dataset["doc_count"];
        if (di["name"] == "") di["name"] = "N/A";
        if (di["name"].indexOf("amd") != -1)
          di["name"] = di["name"].replace("amd", "AMD");
        self.total_processor_data.push(di);
      }
      self.createPie();
    },
    clearPieDataset() {
      let self = this;
      for (let [i, d] of Object.entries(this.labelMapper)) {
        self.countAMD[i] = {};
        self.pieChartAMD[i] = {};
      }
    },

    website_details() {
      let self = this;
      // self.loader = true
      self.rows_details = [];
      self.activePie = false;
      // const url = "/api/websites/details"
      const url = "/api/websites/website_metrics";
      let page = null;
      if (self.selectedPage == 1) page = 1;
      let payload = {};
      payload["website"] = [];
      payload["timestamp"] = self.date.startDate;
      payload["page"] = page;
      payload["processor"] = this.amdCPUFilter;
      payload["item_category"] = self.device;
      if (self.selected_SOVWebsite == "all") {
        for (let [idx, dataset] of Object.entries(self.websitesUrls)) {
          if (!self.oem_websites.includes(idx)) payload["website"].push(idx);
        }
      } else {
        payload["website"].push(self.selected_SOVWebsite);
      }
      this.$http.post(url, payload).then(
        (response) => {
          // this.brand_list = response.body.data.brand_list
          // this.cpu_list = response.body.data.cpu_list
          this.pie_data = response.body.data;
          this.total_pie_data = response.body.total_data;
          // self.loader = false
          self.readyPie();
          // self.readyPieCharts()
        },
        (err) => {
          self.loader = false;
          console.log(err);
        }
      );
    },

    changeCustomDate() {
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format("YYYY-MM-DD");
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.selectedProduct {
  background: #8e8d8d !important;
  color: White !important;
}

.custom-table {
  padding: 10px;
  margin: 10px;
}

.markitamd {
  background-color: #ffb9b9 !important;
}

.markitintel {
  background-color: #c7e0ff !important;
}

.markitsnap {
  background-color: #ffd0f5 !important;
}

.markitna {
  background-color: #edf2fb !important;
}

.markittek {
  background-color: #fff0ce !important;
}

.space-between-header {
  display: flex;
  justify-content: space-between !important;
}

.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}

.space-between-header h3 {
  color: #4e4e4e;
  margin-bottom: 0;
}

.space-between-header h4 {
  color: #4e4e4e;
  margin-bottom: 0;
}

.listing-custom {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
  width: 215px;
  background: #8a87e8;
}

.hint {
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
}

.amd-legend {
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index: 999;
}

.amd-legend i {
  width: fit-content;
}

.amd-legend span {
  padding-left: 4px;
  font-size: 12px;
}

.legending {
  display: inline-block;
  margin-right: 19px;
}

#avgTable th,
#avgTable td {
  border: 1px solid #c8ced3 !important;
  text-align: left;
  font-size: 14px;
}

.mycol {
  padding-right: 15px !important;
  padding-left: 15px !important;
}

.mycols:first-child {
  padding-right: 10px !important;
}

.mycols:nth-child(5) {
  padding-left: 10px;
  padding-right: 10px;
}

.mycols:nth-child(4) {
  padding-left: 15px !important;
}

.mycols:nth-child(3) {
  padding-right: 15px !important;
}

.mycols:last-child {
  padding-left: 10px;
}

.mycols:not(:first-child):not(:last-child) {
  padding-left: 10px;
  padding-right: 10px;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff;
  background-color: #8a87e8;
  border-color: #8a87e8;
  line-height: 35px;
  border-radius: 5px;
}

.btn-outline-secondary {
  height: 35x;
  border-radius: 5px;
  line-height: 17px;
  background: white;
}

.sovdetails {
  float: right;
  height: 30px;
  margin: 0;
  border-radius: 0;
  font-size: 15px;
  padding: 7px;
  width: max-content;
  cursor: pointer;
  margin-left: 4px;
}

select option {
  text-transform: capitalize;
  padding: 10px 0px;
}

/* revamp code  */
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.sovshowdetails {
  float: right;
  border-radius: 0;
  font-size: 12px !important;
  width: max-content !important;
  cursor: pointer;
  /* margin: 4px 5px 0px 0; */
  height: fit-content;
}

#sovSummery {
  font-family: "Poppins", sans-serif !important;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

/* select  */
select {
  font-family: "Poppins", sans-serif;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.dateBadge {
  background: var(--primary_brand);
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff;
  background-color: var(--primary_brand-80);
  border-color: var(--primary_brand-80);
  line-height: 35px;
  padding: 0px 20px;
  border-radius: 5px;
  font-weight: 600;
}

.btn-outline-secondary {
  line-height: 35px;
  /* border-radius: 5px; */
  color: var(--primary_brand);
  background: var(--primary_brand-10);
  border: 1px solid var(--primary_brand-10);
  font-family: "poppins";
  padding: 0px 20px;
}

.btn-group {
  background: var(--primary_brand-10);
  border-radius: 5px;
  font-family: "poppins";

  /* border: 1px solid var(--primary_brand-10); */
}

/*
.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
  border-radius: 5px;
}
.btn-group > .btn:not(:first-child) {
  border-radius: 5px;
} */
.datePickerBadge {
  margin-left: 6px;
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}

.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
}

.exportButton:hover {
  color: white !important;
  background: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}
.customGraphHeading p {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButtonSmall {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 12px;
  font-weight: bold;
  padding: 0px 10px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.navigationButtonSmall:hover {
  background: var(--accent_color-80);
}

.backgroundColorCheck {
  fill: red;
  font-family: "poppins";
}

.searchInput input {
  height: 35px !important;
  margin-right: -5px !important;
  font-size: 14px !important;
  border-color: var(--primary_brand-60) !important;
  font-family: "poppins";
}

.searchInput input::placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins" !important;
  font-size: 16px !important;
}

.searchInput input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:focus {
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
  font-family: "poppins";
}

.searchIcon {
  /* height: 40px; */
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "poppins";

  background-color: var(--primary_brand);
}

.searchIcon img {
  width: 25px;
  margin: 10px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%)
    contrast(104%);
}

.checkbox-btn {
  margin-right: 6px;
  height: 35px !important;
  display: flex;
  align-items: center;
  border: none;
  background-color: var(--base_color-10);
  border-radius: 5px;
  color: #000;
  padding: 0px 10px;
  font-family: "poppins";
}

.checkbox-btn span {
  padding: 0 5px;
  margin-left: 10px;
  font-family: "poppins";
}

.checkbox-btn input {
  margin: 4px;
  font-size: 11px;
  accent-color: #fff;
  width: 15px;
  height: 15px;
  font-family: "poppins";
}

.productListCheckbox {
  display: flex;
  align-items: center;
}

.productListCheckbox input {
  font-size: 11px !important;
  accent-color: var(--primary_brand);
  width: 15px !important;
  height: 15px !important;
}

.productListCheckbox input[type="checkbox"] {
  border: 1px solid var(--primary_brand) !important;
}

.productListCheckbox span {
  margin-left: 10px;
  /* font-weight: 600; */
  font-family: "Poppins", sans-serif !important;
}

.eachProduct:hover {
  background: var(--base_color-20);
}

.productScroll {
  padding-top: 0px;
  cursor: pointer;
  height: 300px;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--base_color-10);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.ratingSection {
  display: flex;
  justify-content: start;
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}

.ratingSectionItem {
  width: 25%;
}
</style>
<style>
.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.modal-title {
  font-weight: 600 !important;
  font-family: "poppins";
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color);
  border: none;
  font-family: "poppins";
  border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
  color: black;
  text-shadow: none;
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 30px;
  background: var(--primary_brand-10);
  opacity: inherit;
  padding: 5px 10px;
  border-radius: 25px;
}

.borderBetween {
  border-bottom: 0.13rem solid #e1e1e1 !important;
  margin: 20px 0px !important;
}

.borderLeft {
  border-right: 0.13rem solid #e1e1e1 !important;
}

.borderRight:first-child {
  border-right: 1px solid #e1e1e1;
}
</style>
